<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title v-if="id && !readonly" sliding>{{$t('formatos.editar') + (formato ? ' - ' + formato.codigo + ' - ' + formato.nombre : '')}}</f7-nav-title>
      <f7-nav-title v-else-if="id" sliding>{{$t('formatos.formato') + (formato ? ' - ' + formato.codigo + ' - ' + formato.nombre : '')}}</f7-nav-title>
      <f7-nav-title v-else sliding>{{$t('formatos.nuevoFormato')}}</f7-nav-title>
      <f7-nav-right>
          <f7-button
            v-if="!readonly"
            fill
            icon-f7="eye_fill"
            v-tooltip="'Volver a modo lectura'"
            :text="'Ver'"
            class="display-flex"
            @click="readonly=true"
          ></f7-button>
          <f7-button
            v-if="!readonly"
            fill
            icon-f7="floppy_disk"
            :text="$t('common.guardar')"
            class="display-flex"
            @click="$refs.rform.saveItem()"
          ></f7-button>
          <f7-button
            v-if="readonly && !enVigor"
            fill
            icon-f7="pencil"
            :text="$t('common.editar')"
            class="display-flex"
            @click="readonly=false"
          ></f7-button>
          <!-- #1001 · Un formato en vigor no se edita en sitio: en lugar de «Editar», el aviso de por
               qué y la salida, juntos y en el mismo sitio que el botón que sustituyen. -->
          <span v-if="enVigor" class="aviso-formato-en-vigor">{{ mensajeEnVigor }}</span>
          <f7-button
            v-if="enVigor && !guardado.versionSiguiente && puedeCrearEdicion"
            fill
            icon-f7="square_stack_3d_up"
            text="Crear edición nueva"
            class="display-flex"
            :href="`/formatos/version/${guardado.id}/`"
          ></f7-button>
          <f7-button
            v-if="enVigor && guardado.versionSiguiente && puedeVerEdicionSiguiente"
            fill
            icon-f7="arrow_right_square"
            text="Ir a la edición nueva"
            class="display-flex"
            :href="`/formatos/view/${guardado.versionSiguiente}/`"
          ></f7-button>
        <template slot="right">
          <div class="menu-item menu-item-dropdown bg-color-primary">
            <div class="menu-item-content"><i class="f7-icons">ellipsis_vertical</i></div>
            <div class="menu-dropdown menu-dropdown-right bg-color-primary">
              <div class="menu-dropdown-content bg-color-primary text-align-right">
                <div class="menu-dropdown-item menu-close pointer" v-if="!readonly" @click="importarComprobaciones()">{{$t('formatos.importarComprobaciones')}}</div>
                <div class="menu-dropdown-item menu-close pointer" v-if="formato && formato.id" @click="exportarComprobaciones()">{{$t('formatos.exportarComprobaciones')}}</div>
                <div class="menu-dropdown-divider"></div>
                <div class="menu-dropdown-item menu-close pointer" v-if="readonly && !enVigor" @click="readonly=false">{{$t('common.editar')}}</div>
                <div class="menu-dropdown-item menu-close pointer" v-if="readonly" @click="copy">{{$t('common.copy')}}</div>
                <div class="menu-dropdown-item menu-close pointer" v-if="!readonly" @click="$refs.popuppaste.open()">{{$t('common.paste')}}</div>
                <div class="menu-dropdown-item menu-close pointer" v-if="!readonly" @click="cancelarEdicion()">{{$t('common.cancelar')}}</div>
                <div class="menu-dropdown-divider"></div>
                <div class="menu-dropdown-item menu-close pointer" v-roles="['ADMIN', 'DTYCAL']" v-if="readonly && formato && formato.listadoCondicionesAuditoria && formato.listadoCondicionesAuditoria.length && formato.listadoCondicionesAuditoria.some(r=>r.regla)" @click="probarAuditoria = true">{{$t('Probar auditoria GPT')}}</div>
                <div class="menu-dropdown-divider"></div>
                <div class="menu-dropdown-item menu-close pointer mapeo-item-canonico-beta" v-roles="['ADMIN', 'DTYCAL']" v-if="formato && formato.id" @click="sugerirMapeoItemEnriquecido">🧪 Sugerir mapeo de item enriquecido (IA) <span class="mapeo-item-canonico-beta-tag">beta</span></div>
              </div>
            </div>
          </div>
        </template>
      </f7-nav-right>
    </f7-navbar>
    <r-form
      ref="rform"
      :itemId="version ? null : id"
      @save="onSave"
      :readonly="readonly"
      :dbAdapter="Formato"
      class="full-height"
      classContent="full-height flex-direction-row"
      @loadItem="loadItem"
      :documentoAdapter="Documento"
      :beforeSave="beforeSaveFormato"
      :defaultData="{tabs: [], caracteristicas: [], comprobaciones: [], precargas:[], plantillasInforme:[ {provincias: [], condiciones: [], anexos: []}], nombreCategoriasDefectos: {}}"
    >
      <template v-slot="{rform}">
        <div class="page-content" style="flex:1;--f7-navbar-height: 0px;">
          <f7-subnavbar>
            <f7-segmented raised class="elevation-6">
              <f7-button
                fill
                tab-link="#tab-general"
                v-tooltip="'Esta pestaña nos muestra los datos generales del formato'"
                tab-link-active
                @click="tabActive = 'GENERAL'"
              >{{$t('formatos.datosGenerales')}}</f7-button>
              <f7-button fill tab-link="#tab-instalacion" @click="tabActive = 'INSTALACION'">Instalación</f7-button>
              <f7-button fill tab-link="#tab-tomadedatos" @click="tabActive = 'TOMADATOS'">Toma de datos</f7-button>
              <f7-button v-noroles="['ENAC', 'PRODUCCION']" fill tab-link="#tab-precargas" v-if="precargaHabilitada" @click="tabActive = 'PRECARGAS'">
                Precargas
                <!-- Botón para alternar precargas: Ocultar / Mostrar según datos -->
                <span style="float: right;">
                  <f7-button
                    v-if="$refs.rform && $refs.rform.formData && ($refs.rform.formData.precargas && $refs.rform.formData.precargas.length || ($refs.rform.formData.camposPersonalizados && $refs.rform.formData.camposPersonalizados.precargas && $refs.rform.formData.camposPersonalizados.precargas.length))"
                    small
                    style="border: 1px solid orange; border-radius: 5px;font-size: 9px;position:relative; top:4px;"
                    v-tooltip="enVigor ? mensajeEnVigor : ''"
                    @click.stop="toggleSwitchPrecargas()"
                  >
                    {{ getSwitchPrecargasLabel() }} precargas
                  </f7-button>
                </span>
              </f7-button>
              <f7-button fill tab-link="#tab-modelosinforme" @click="tabActive = 'MODELOSINFORME'">Modelos informe</f7-button>
            </f7-segmented>
          </f7-subnavbar>
          <f7-tabs class="full-height" ref="tabs">
            <f7-tab id="tab-general" class="page-content no-padding" tab-active>
              <Container group-name="grupo-general">
                <f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
                  <f7-block-title>
                    <div class="label-group col-100">
                      {{$t('formatos.datosGenerales')}}
                      <!-- mostramos u ocultamos los datos generales del formato -->
                      <span style="float:right;">
                        <f7-link @click="showDatosGenerales = !showDatosGenerales" :icon-f7="showDatosGenerales?'chevron_up':'chevron_down'" v-tooltip="showDatosGenerales?'Ocultar':'Mostrar'"></f7-link>
                      </span>
                    </div>
                  </f7-block-title>
                  <div v-if="showDatosGenerales">
                    <f7-card-content>
                      <f7-row no-gap class="list list-form no-hairlines">
                        <r-input
                          class="col-15"
                          floating-label
                          :label="$t('formatos.codigo')"
                          :form="rform"
                          type="text"
                          name="codigo"
                          :readonly="typeOf(id) != 'undefined' && !codigoEdicionEditable"
                        ></r-input>
                        <r-input
                          class="col-35"
                          floating-label
                          :label="$t('formatos.nombre')"
                          :form="rform"
                          type="text"
                          name="nombre"
                        ></r-input>
                        <r-autocomplete
                          :dbAdapter="Materia"
                          class="col-25"
                          floating-label
                          :label="$t('formatos.materia')"
                          :form="rform"
                          name="materia.codigo"
                          labelProp="nombre"
                          idProp="codigo"
                          idFieldDetail="id"
                        ></r-autocomplete>
                        <r-input
                          class="col-25"
                          floating-label
                          label="Mostrar botón calcular"
                          :form="rform"
                          name="mostrarCalcular"
                          type="check"
                        ></r-input>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('formatos.fechaDesde')"
                          :form="rform"
                          type="datepicker"
                          name="fechaDesde"
                          :clearButton="true"
                          :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit'} }"
                        >
                          <!-- #1001 · Se avisa antes de guardar: después, el formato ya no admite cambios en sitio. -->
                          <template slot="info" v-if="!rform.readonly && rform.formData && fechaYaLlegada(rform.formData.fechaDesde)">
                            Con esta fecha, al guardar el formato entra en vigor y ya no se podrá modificar: los cambios irán en una edición nueva.
                          </template>
                        </r-input>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('formatos.fechaHasta')"
                          :form="rform"
                          type="datepicker"
                          name="fechaHasta"
                          :clearButton="true"
                          :calendar-params="{closeOnSelect:true,routableModals:false, dateFormat: { year:'numeric', month: '2-digit', day: '2-digit'} }"
                        ></r-input>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('formatos.periodicidadMeses')"
                          :form="rform"
                          name="periodicidadMeses"
                          type="number"
                        ></r-input>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('formatos.inspeccionable')"
                          :form="rform"
                          name="inspeccionable"
                          type="check"
                        ></r-input>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('formatos.tipomedida')"
                          :form="rform"
                          name="conTipoMedidaAAdoptar"
                          type="check"
                        ></r-input>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('formatos.faltaMantenimiento')"
                          :form="rform"
                          name="conFaltaMantenimiento"
                          type="check"
                        ></r-input>
                        <r-autocomplete-m2m
                          class="col-33"
                          :dbAdapter="Provincia"
                          floating-label
                          :label="$t('formatos.provincias')"
                          :form="rform"
                          :name="'provincias'"
                          labelProp="nombre"
                          :shownFields="['codigo','nombre']"
                          idProp="codigo"
                          nameId="provinciasCodigo"
                          type="textarea"
                          :lineBreak="true"
                        ></r-autocomplete-m2m>
                        <r-autocomplete-m2m
                          class="col-33"
                          :dbAdapter="Formato"
                          floating-label
                          :label="$t('formatos.formatosCompatibles')"
                          :form="rform"
                          :name="'formatosCompatibles'"
                          labelProp="nombre"
                          prefixProp="codigo"
                          :shownFields="['codigo','nombre']"
                          idProp="codigo"
                          type="textarea"
                          :lineBreak="true"
                        ></r-autocomplete-m2m>
                        <r-input
                          v-noroles="['ENAC', 'PRODUCCION']"
                          class="col-25"
                          floating-label
                          :label="$t('formatos.comprobacionesEnPlantillas')"
                          :form="rform"
                          name="comprobacionesEnPlantillas"
                          type="check"
                        ></r-input>
                        <r-input
                          v-noroles="['ENAC', 'PRODUCCION']"
                          class="col-25 bgcolor-item"
                          floating-label
                          :label="$t('formatos.materiaEnItem')"
                          :form="rform"
                          name="materiaEnItem"
                          type="check"
                        ></r-input>
                        <r-input
                          v-noroles="['ENAC', 'PRODUCCION']"
                          class="col-25"
                          floating-label
                          :label="$t('formatos.tiempoInspMin')"
                          :form="rform"
                          name="tiempoInspMin"
                          type="number"
                        ></r-input>
                        <r-input
                          v-noroles="['ENAC', 'PRODUCCION']"
                          class="col-25"
                          floating-label
                          :label="$t('formatos.tiempoInspMax')"
                          :form="rform"
                          name="tiempoInspMax"
                          type="number"
                        ></r-input>
                      </f7-row>
                    </f7-card-content>
                    <f7-block-title><div class="label-group col-100">{{$t('formatos.textoCategoriasDefectos')}}</div></f7-block-title>
                    <f7-card-content>
                      <f7-row no-gap class="list list-form no-hairlines">
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('formatos.defectoLeve')"
                          :form="rform"
                          name="nombreCategoriasDefectos.DL"
                        ></r-input>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('formatos.defectoGrave')"
                          :form="rform"
                          name="nombreCategoriasDefectos.DG"
                        ></r-input>
                        <r-input
                          class="col-33"
                          floating-label
                          :label="$t('formatos.defectoMuyGrave')"
                          :form="rform"
                          name="nombreCategoriasDefectos.DMG"
                        ></r-input>
                      </f7-row>
                    </f7-card-content>
                    <f7-block-title><div class="label-group col-100">Ayuda periodicidad</div></f7-block-title>
                    <f7-row no-gap class="list list-form no-hairlines">
                      <r-rich-text-input
                        :disabled="rform.readonly"
                        class="col-100"
                        :form="rform"
                        :name="'ayudaPeriodicidad'"
                      ></r-rich-text-input>
                    </f7-row>
                  </div>
                </f7-card>



                <f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
                  <f7-block-title>
                    <div class="label-group col-100">
                      Condiciones para auditoría de inspecciones
                      <!-- Añadir Condición de auditoría -->
                      <f7-link v-if="!rform.readonly && rform.formData" @click="nuevaReglaAuditoria()" icon-f7="plus_square_fill" v-tooltip="'Crear nueva regla'"></f7-link>
                      <!-- Añadir múltiples reglas de una vez, usando un diálogo con un textbox -->
                      <f7-link v-if="!rform.readonly && rform.formData" @click="popupMultiReglaOpened = true;" icon-f7="plus_square_fill_on_square_fill" v-tooltip="'Crear múltiples reglas'"></f7-link>
                      <!-- Ver todas las reglas en modo texto -->
                      <f7-link v-if="rform.formData && rform.formData.listadoCondicionesAuditoria && rform.formData.listadoCondicionesAuditoria.length" @click="verReglasAuditoriaComoTexto()" icon-f7="textbox" v-tooltip="'Ver todas las reglas'"></f7-link>
                      <r-input style="display: inline-flex;border: 1px solid gray;border-radius: 5px;" label="Reglas de auditoría activas" :form="rform" type="check" :simple="true" name="activarReglasAuditorias"></r-input>
                      <!-- Generación automática del conjunto de condiciones de auditoría -->
                      <f7-button
                        v-if="!rform.readonly && rform.formData && rform.formData.id"
                        v-roles="['ADMIN', 'DTYCAL']"
                        class="ia-btn margin-left-half"
                        style="display: inline-flex;width: auto !important;"
                        small
                        fill
                        :disabled="generandoCondicionesIA"
                        @click="generarCondicionesConIA()"
                        v-tooltip="generandoCondicionesIA ? 'Ya hay una pasada en marcha para este formato' : 'Genera las condiciones de auditoría que faltan, con su texto y su código, a partir de las características, las comprobaciones y la normativa aplicable'"
                      >
                        <f7-icon f7="wand_stars" size="16"></f7-icon>
                        &nbsp;{{ generandoCondicionesIA ? 'Generando…' : 'Generar reglas' }}
                      </f7-button>
                      <!-- Plegado por defecto: no se usa en cada pasada y esta barra ya va cargada.
                           El punto avisa de que hay instrucciones escritas aunque este cerrado, que
                           si no se generaria con ellas sin recordar que estaban ahi. -->
                      <f7-link
                        v-if="!rform.readonly && rform.formData && rform.formData.id"
                        v-roles="['ADMIN', 'DTYCAL']"
                        class="margin-left-half"
                        :icon-f7="mostrarInstruccionesIA ? 'chevron_up_square' : 'text_badge_plus'"
                        :color="instruccionesIA && instruccionesIA.trim() ? 'green' : ''"
                        @click="alternarInstruccionesIA()"
                        v-tooltip="'Instrucciones para la generación de las reglas'"
                      ></f7-link>

                      <!-- mostramos u ocultamos el listado de condiciones de auditoria -->
                      <!-- Recuperación de una pasada que se cortó antes de guardar: lo generado
                           quedó en servidor y se puede volver a traer. -->
                      <f7-button
                        v-if="!rform.readonly && propuestasPendientesIA.length && !generandoCondicionesIA"
                        v-roles="['ADMIN', 'DTYCAL']"
                        class="ia-btn margin-left-half"
                        style="display: inline-flex;width: auto !important;"
                        small
                        outline
                        @click="recuperarPropuestasPendientes()"
                        v-tooltip="'Una pasada anterior generó estas condiciones y no llegaron a guardarse'"
                      >
                        Recuperar {{ propuestasPendientesIA.length }} sin guardar
                      </f7-button>
                      <span style="float:right;">
                        <f7-link @click="alternarCondicionesAuditoria()" :icon-f7="showCondicionesAuditoria?'chevron_up':'chevron_down'" v-tooltip="showCondicionesAuditoria?'Ocultar':'Mostrar'"></f7-link>
                      </span>
                    </div>
                  </f7-block-title>
                  <!-- Instrucciones para ESTA generación. Mandan sobre las directrices, así que se
                       dice en la propia pantalla: quien lo escribe tiene que saber que gana. -->
                  <div v-if="mostrarInstruccionesIA && !rform.readonly" class="instrucciones-ia">
                    <div class="instrucciones-ia-titulo">
                      Instrucciones para la generación de las reglas
                      <span class="instrucciones-ia-nota">
                        prevalecen sobre las directrices · el barrido las aplica en cada sección,
                        así que una cantidad («solo 3 reglas») se entiende por sección
                      </span>
                    </div>
                    <!-- Bloqueado mientras corre la pasada: las instrucciones se mandan UNA vez, en
                         el POST inicial. Editable durante los minutos que dura el barrido, cualquier
                         cambio parecería estar aplicándose —el indicador se pondría verde— y no
                         afectaría a nada de lo que se está generando. -->
                    <textarea
                      v-model="instruccionesIA"
                      :maxlength="MAX_INSTRUCCIONES_IA"
                      :readonly="generandoCondicionesIA"
                      class="instrucciones-ia-texto"
                      :class="{'instrucciones-ia-bloqueado': generandoCondicionesIA}"
                      :placeholder="generandoCondicionesIA
                        ? 'Hay una pasada en marcha: lo que escribas ahora se aplicará en la siguiente.'
                        : 'Por ejemplo: genera solo 3 reglas sobre el grupo A.-PUERTAS, para probar.'"
                    ></textarea>
                    <div class="instrucciones-ia-alcance">
                      <!-- Acotar la sección es lo que hace que un "genera solo 3" se cumpla de
                           verdad: el barrido recorre las secciones una a una y cada una lee la
                           cantidad como suya, así que sobre el formato entero serían 3 por sección.
                           Por parámetro sí es un tope; por frase, solo una petición. -->
                      Generar en
                      <select v-model="seccionIA" :disabled="generandoCondicionesIA || cargandoSeccionesIA">
                        <option value="">
                          {{ cargandoSeccionesIA
                            ? 'cargando las secciones…'
                            : 'todas las secciones' + (seccionesDisponiblesIA.length ? ' (' + seccionesDisponiblesIA.length + ')' : '') }}
                        </option>
                        <option v-for="(sec, i) in seccionesDisponiblesIA" :key="'sec-'+i" :value="sec.clave">
                          {{ sec.nombre }}
                        </option>
                      </select>
                      <span v-if="!seccionIA && instruccionesIA && instruccionesIA.trim()" class="instrucciones-ia-tope">
                        · una cantidad se aplicará en cada sección
                      </span>
                    </div>
                    <div class="instrucciones-ia-pie">
                      <!-- "En uso" solo si la pasada la lanzó ESTA pestaña. Si la lanzó otro, sus
                           instrucciones son las suyas y las de aquí no están participando: decir
                           que están en uso sería atribuirle a este texto un efecto que no tiene. -->
                      <span v-if="generandoCondicionesIA && pasadaIAEsPropia" class="instrucciones-ia-tope">
                        En uso por la pasada que has lanzado · no se puede cambiar hasta que termine
                      </span>
                      <span v-else-if="generandoCondicionesIA" class="instrucciones-ia-nota">
                        Hay una pasada en marcha lanzada desde otro sitio, con sus propias
                        instrucciones. Este texto se guardará para la siguiente que lances tú.
                      </span>
                      <span v-else :class="{'instrucciones-ia-tope': (instruccionesIA || '').length > MAX_INSTRUCCIONES_IA - 200}">
                        {{ (instruccionesIA || '').length }} / {{ MAX_INSTRUCCIONES_IA }}
                      </span>
                      <f7-link v-if="instruccionesIA && !generandoCondicionesIA" @click="instruccionesIA = ''">Vaciar</f7-link>
                    </div>
                  </div>

                  <!-- Narración del barrido de generación: mismo grafismo que el resto de las
                       funcionalidades de IA para que resulte familiar. -->
                  <div v-if="generandoCondicionesIA" class="display-flex" style="align-items: center; gap: 12px;">
                    <r-ia-pensando
                      :narracion="narracionCondicionesIA"
                      latin-default="Generating"
                      texto-default="Generando condiciones de auditoría…"
                    ></r-ia-pensando>
                    <f7-button small outline color="orange" style="width: auto !important;" @click="pararGeneracionIA('DETENER')"
                      v-tooltip="'Termina la sección en curso y conserva todo lo generado hasta ahora'">
                      Detener
                    </f7-button>
                    <f7-button small outline color="red" style="width: auto !important;" @click="pararGeneracionIA('CANCELAR')"
                      v-tooltip="'Aborta y deja el listado como estaba antes de empezar'">
                      Cancelar
                    </f7-button>
                    <!-- La pasada corre en servidor: puede haberla lanzado otra persona desde
                         otro navegador, y conviene saberlo antes de detenerla. -->
                    <span v-if="usuarioGeneracionIA" class="text-color-gray" style="font-size: 11px;">
                      lanzada por {{ usuarioGeneracionIA }}
                    </span>
                  </div>
                  <!-- Cronograma: una fila por sección del formato, con su estado y su tiempo.
                       Se queda visible al terminar para poder analizar dónde se va el tiempo. -->
                  <div v-if="cronogramaIA.length" class="cronograma-ia">
                    <div class="display-flex" style="justify-content: space-between; align-items: center;">
                      <span class="ia-text">Cronograma por sección</span>
                      <span class="text-color-gray" style="font-size: 11px;">
                        {{ cronogramaHechas }}/{{ cronogramaIA.length }} secciones
                        · {{ cronogramaPropuestas }} propuestas
                        <template v-if="verCostesIA && costeAcumuladoIA && !generandoCondicionesIA">
                          · ${{ costeAcumuladoIA.toFixed(2) }} acumulados
                        </template>
                        <template v-if="cronogramaCompletoIA && !generandoCondicionesIA">
                          · <b class="text-color-green">completo</b>
                        </template>
                        <template v-if="cronogramaMediaSegundos"> · media {{ cronogramaMediaSegundos }}s</template>
                        <template v-if="generandoCondicionesIA && cronogramaRestante"> · quedan ~{{ cronogramaRestante }}</template>
                      </span>
                    </div>
                    <table class="cronograma-ia-tabla">
                      <thead>
                        <tr>
                          <th class="col-seccion">Sección</th><th class="col-estado">Estado</th><th class="col-tiempo">Tiempo</th><th class="col-reglas">Reglas</th><th v-if="verCostesIA" class="col-coste">Coste</th><th class="col-detalle">Dónde se fue el tiempo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(fila, iFila) in cronogramaIA" :key="'crono-'+iFila" :class="'crono-' + fila.estado">
                          <td class="col-seccion" v-tooltip="fila.nombre">{{ fila.nombre }}</td>
                          <td class="col-estado">{{ etiquetaEstadoCrono(fila.estado) }}</td>
                          <td class="col-tiempo">{{ fila.ms ? (fila.ms/1000).toFixed(1) + 's' : (fila.estado === 'curso' ? '…' : '-') }}</td>
                          <td class="col-reglas">{{ fila.estado === 'hecha' || fila.estado === 'error' ? fila.propuestas : '' }}</td>
                          <!-- El coste sale también en las secciones con error: lo gastado antes
                               de reventar está pagado igual y esconderlo falsea el total. -->
                          <td v-if="verCostesIA" class="col-coste">{{ fila.costeUsd ? '$' + fila.costeUsd.toFixed(3) : '' }}</td>
                          <td style="font-size: 11px;" class="text-color-gray col-detalle">{{ fila.detalle || '' }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- Coste: el total en la línea y el desglose por modelo al desplegar.
                         La generación es dual, así que sin el desglose no se sabe cuál de los
                         dos proveedores se lleva el dinero. -->
                    <div v-if="verCostesIA && costesIAOrdenados.length" class="costes-ia">
                      <span @click="mostrarCostesIA = !mostrarCostesIA" style="cursor: pointer;">
                        <f7-icon :f7="mostrarCostesIA ? 'chevron_down' : 'chevron_right'" size="12"></f7-icon>
                        Coste acumulado del formato: <b>${{ costeTotalIA.toFixed(4) }}</b>
                        <template v-if="!mostrarCostesIA"> · {{ costesIAOrdenados.length }} modelos</template>
                      </span>
                      <table v-if="mostrarCostesIA" class="cronograma-ia-tabla">
                        <thead>
                          <!-- Escritura y lectura de caché van separadas y hay una columna de
                               total: juntarlas escondía la caché escrita, que no es gratis
                               (1,25x la entrada) y hacía parecer que un modelo recibía menos
                               texto que el otro cuando era al revés. -->
                          <tr><th>Modelo</th><th>Llamadas</th><th>Entrada nueva</th><th>Caché leída</th><th>Caché escrita</th><th>Entrada total</th><th>Salida</th><th>Coste</th></tr>
                        </thead>
                        <tbody>
                          <tr v-for="m in costesIAOrdenados" :key="'coste-'+m.modelo">
                            <td>{{ m.modelo }}</td>
                            <td>{{ m.llamadas }}</td>
                            <td>{{ (m.entrada || 0).toLocaleString('es-ES') }}</td>
                            <td>{{ (m.cacheLectura || 0).toLocaleString('es-ES') }}</td>
                            <td>{{ (m.cacheEscritura || 0).toLocaleString('es-ES') }}</td>
                            <td><b>{{ entradaTotalIA(m).toLocaleString('es-ES') }}</b></td>
                            <td>{{ (m.salida || 0).toLocaleString('es-ES') }}</td>
                            <td>${{ (m.costeUsd || 0).toFixed(4) }}
                              <span v-if="m.fuentePrecio === 'estimada'" class="text-color-gray"
                                v-tooltip="'Tarifa estimada: confírmala en la factura del proveedor'">*</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <f7-popup ref="popupCondicionesAuditoriaTexto" v-if="popupCondicionesAuditoriaOpened" @popup:close="popupCondicionesAuditoriaOpened = false" :opened="true" style="--f7-popup-tablet-width: 75%;">
                    <f7-page>
                      <f7-navbar>
                        <f7-nav-left><f7-link v-if="rform.formData" @click="copiarAlPortapapeles(rform.formData.condicionesAuditoriaTexto.replaceAll('<br/>',''))" v-tooltip="'Copiar las reglas'">Copiar</f7-link></f7-nav-left>
                        <f7-nav-title>{{$t('Condiciones de auditoría en texto')}}</f7-nav-title>
                        <f7-nav-right></f7-nav-right>
                      </f7-navbar>
                      <div style="margin: 12px;" v-html="rform.formData.condicionesAuditoriaTexto"></div>
                    </f7-page>
                  </f7-popup>
                  <f7-popup ref="popupReglaInfo" v-if="popupReglaInfoOpened && rform.formData.reglaSeleccionada" @popup:close="popupReglaInfoOpened = false" :opened="true" style="--f7-popup-tablet-width: 75%;">
                    <detalle-regla :rform="rform" v-if="rform && rform.formData && rform.formData.reglaSeleccionada"></detalle-regla>
                  </f7-popup>
                  <f7-popup ref="popupMultiRegla" v-if="popupMultiReglaOpened" @popup:close="popupMultiReglaOpened = false" :opened="true" style="--f7-popup-tablet-width: 75%;">
                    <f7-page>
                      <f7-navbar>
                        <f7-nav-left><f7-link v-if="!rform.readonly && rform.formData" @click="nuevaReglaAuditoriaMultiple()" v-tooltip="'Crear múltiples reglas'">Crear</f7-link></f7-nav-left>
                        <f7-nav-title>Crear multiples reglas</f7-nav-title>
                        <f7-nav-right></f7-nav-right>
                      </f7-navbar>
                      <div class="textarea-reglas">
                        <f7-row no-gap class="list list-form row-100">
                          <f7-col width="100" medium="100">
                            <r-input
                              class="row-100"
                              style="z-index: 3000;"
                              floating-label
                              outline
                              label="Listado de reglas separadas por líneas"
                              :form="rform"
                              type="textarea"
                              name="nuevasReglas"
                              :clearButton="false"
                            ></r-input>
                          </f7-col>
                        </f7-row>
                      </div>
                    </f7-page>
                  </f7-popup>
                  <div v-if="showCondicionesAuditoria">
                    <!-- Barra del modo borrado. Existe SOLO en este modo a proposito: asi el listado
                         normal se queda como estaba y el check de seleccion no se confunde con el de
                         "Comprobada", que es un campo que SE GUARDA en el formato y significa otra
                         cosa (regla ya revisada, no la toques al regenerar). -->
                    <f7-row v-if="enModoBorrado(rform)" no-gap class="barra-borrado-reglas">
                      <input
                        type="text"
                        v-model="filtroBorradoReglas"
                        placeholder="Filtrar por texto de la regla o por su codigo…"
                        class="filtro-borrado-reglas"
                      />
                      <span class="acciones-borrado-reglas">
                        <f7-button
                          small raised fill color="red"
                          :disabled="!seleccionadasVigentes(rform).length"
                          @click="borrarReglasSeleccionadas()"
                        >
                          Eliminar {{ seleccionadasVigentes(rform).length }}
                        </f7-button>
                        <!-- Marca y desmarca las que se estan viendo. Un solo control para las dos
                             cosas: con el filtro puesto, marcar y desmarcar son el mismo gesto. -->
                        <f7-link
                          @click="alternarSeleccionVisibles(rform)"
                          :icon-f7="todasVisiblesSeleccionadas(rform) ? 'checkmark_square_fill' : 'square'"
                          color="red"
                          v-tooltip="(todasVisiblesSeleccionadas(rform) ? 'Desmarcar' : 'Marcar') + ' las ' + reglasVisiblesAuditoria(rform).length + ' que se estan viendo'"
                        ></f7-link>
                        <span class="etiqueta-marcar-visibles" @click="alternarSeleccionVisibles(rform)">
                          {{ todasVisiblesSeleccionadas(rform) ? 'Desmarcar' : 'Marcar' }}
                          las {{ reglasVisiblesAuditoria(rform).length }} que se están viendo
                        </span>
                      </span>
                      <f7-button small @click="alternarModoBorradoReglas()">Cancelar</f7-button>
                      <span class="cuenta-borrado-reglas">
                        {{ seleccionadasVigentes(rform).length }} seleccionadas de
                        {{ (rform.formData.listadoCondicionesAuditoria || []).length }}
                      </span>
                    </f7-row>
                    <f7-row no-gap>
                      <f7-col v-if="enModoBorrado(rform)" class="cabecera-condiciones" style="width: 3%;"></f7-col>
                      <f7-col class="cabecera-condiciones" style="width: 5%;">
                        <f7-link v-if="!rform.readonly && rform.formData && rform.formData.listadoCondicionesAuditoria && rform.formData.listadoCondicionesAuditoria.length" @click="marcarDesmarcarCondicionesAuditoria()" :icon-f7="marcadoCondicionesAuditoria?'square':'checkmark_square_fill'" v-tooltip="(marcadoCondicionesAuditoria?'Marcar':'Desmarcar')+' todas las condiciones'"></f7-link>
                        <span class="etiqueta-columna" v-tooltip="'Reglas ya revisadas: la regeneracion no las toca'">Comprobada</span>
                      </f7-col>
                      <f7-col class="cabecera-condiciones" style="width: 4%;" v-tooltip="Activa">
                        <f7-link v-if="!rform.readonly && rform.formData && rform.formData.listadoCondicionesAuditoria && rform.formData.listadoCondicionesAuditoria.length" @click="activarDesactivarTodasCondicionesAuditoria()" :icon-f7="activadoCondicionesAuditoria?'square':'checkmark_square_fill'" v-tooltip="(activadoCondicionesAuditoria?'Activar':'Desactivar')+' todas las condiciones'"></f7-link>
                        <span class="etiqueta-columna" v-tooltip="'Si la regla se evalua en la auditoria'">Activa</span>
                      </f7-col>
                      <f7-col class="cabecera-condiciones cabecera-texto" :style="'width: ' + (enModoBorrado(rform) ? '85%' : '88%') + ';'">Texto condición</f7-col>
                      <!-- La UNICA papelera del listado, sobre la columna de acciones de las filas.
                           Antes habia una por linea y otra en la barra de la tarjeta que borraba
                           todas: con cientos de reglas generadas, la de linea convertia una limpieza
                           en trabajo de una tarde, y la de "todas" era demasiado grosera. Esta entra
                           en modo borrado, donde aparecen el filtro y un check por regla. -->
                      <f7-col class="cabecera-condiciones" style="width: 2.3%;">
                        <f7-link
                          v-if="!rform.readonly && rform.formData && rform.formData.listadoCondicionesAuditoria && rform.formData.listadoCondicionesAuditoria.length"
                          @click="alternarModoBorradoReglas()"
                          icon-f7="trash"
                          :color="modoBorradoReglas ? 'gray' : 'red'"
                          v-tooltip="modoBorradoReglas ? 'Salir del modo borrado' : 'Seleccionar reglas para borrar'"
                        ></f7-link>
                      </f7-col>
                    </f7-row>
                    <f7-row
                      no-gap
                      :class="'list list-form no-hairlines reglasAuditoria linea-regla-' + rform.formData.listadoCondicionesAuditoria[indexRegla].tipoRegla"
                      v-for="({ regla, indexRegla }) in reglasVisiblesAuditoria(rform)"
                      :key="'listadoCondicionesAuditoria-'+indexRegla"
                      :style="'margin-left: 12px;' + (regla.activa?'border: 2px solid green;':'border: 2px solid orange;')"
                    >
                      <!-- Seleccion para borrar. NO es un campo del formato: vive en la pantalla y
                           desaparece al salir del modo, asi que no puede acabar guardada. -->
                      <f7-col v-if="enModoBorrado(rform)" style="width: 3%;padding: 0 12px;" class="padding-horizontal-half display-flex">
                        <f7-link
                          @click="alternarSeleccionBorrado(regla)"
                          :icon-f7="estaSeleccionadaParaBorrar(regla) ? 'checkmark_square_fill' : 'square'"
                          color="red"
                          v-tooltip="'Marcar esta regla para borrarla'"
                        ></f7-link>
                      </f7-col>
                      <f7-col style="width: 2.5%;padding: 0 12px;" class="padding-horizontal-half display-flex">
                        <r-input
                          :form="rform"
                          :name="'listadoCondicionesAuditoria.'+indexRegla+'.comprobada'"
                          type="check"
                          :simple="true"
                          v-tooltip="'Marcaremos este check cuando la regla haya sido comprobada y ya no se modificará por la regeneración de reglas.'"
                        ></r-input>
                      </f7-col>
                      <f7-col style="width: 2.5%;padding: 0 12px;" class="padding-horizontal-half display-flex">
                        <f7-link v-if="regla.regla && regla.regla.regla" @click="detalleReglaAuditoria(indexRegla)" :color="regla.regla.error?'red':''" icon-f7="info_circle_fill" v-tooltip="'Ver detalles: '+regla.regla.regla" ></f7-link>
                        <f7-link v-if="!readonly && (!regla.regla || !regla.regla.regla)" @click="regla.regla={valoresAfectados:[]};detalleReglaAuditoria(indexRegla)" icon-f7="plus_circle" v-tooltip="'Crear regla manualmente'" ></f7-link>
                        <!-- Solo en las reglas que ha propuesto la IA. El color dice cuánto
                             coincidieron los dos modelos, que es lo que marca cuánta revisión
                             pide cada regla; el detalle completo, al pulsarlo. -->
                        <f7-link
                          v-if="esReglaDeIA(regla)"
                          @click="verOrigenIA(regla)"
                          :icon-f7="iconoOrigenIA(regla)"
                          :color="colorOrigenIA(regla)"
                          v-tooltip="tooltipOrigenIA(regla)"
                        ></f7-link>
                        <div class="numero-regla" v-roles="['ADMIN']">
                        </div>
                      </f7-col>
                      <f7-col style="width: 2%;padding: 0 12px;" class="padding-horizontal-half display-flex">
                        <div class="small-links-container">
                          <f7-link v-if="!readonly" class="link-arriba" icon-f7="cloud_upload_fill" :color="regla.evalOnSync?'green':'gray'" @click="regla.evalOnSync = !!!regla.evalOnSync" v-tooltip="'Ejecutar en la app'" ></f7-link>
                          <f7-link v-else class="link-arriba" icon-f7="cloud_upload_fill" :color="regla.evalOnSync?'green':'gray'" v-tooltip="'Ejecutar al sincronizar'" ></f7-link>
                          <f7-link v-if="!readonly" class="link-abajo" icon-f7="flag_fill" :color="regla.evalOnFinish?'green':'gray'"  @click="regla.evalOnFinish = !!!regla.evalOnFinish" v-tooltip="'Ejecutar antes de firma'" ></f7-link>
                          <f7-link v-else class="link-abajo" icon-f7="flag_fill" :color="regla.evalOnFinish?'green':'gray'"  v-tooltip="'Ejecutar al finalizar'" ></f7-link>
                        </div>
                        <r-input
                          :form="rform"
                          :name="'listadoCondicionesAuditoria.'+indexRegla+'.activa'"
                          type="check"
                          v-tooltip="'la regla está ' + (regla.activa?'activa':'inactiva') + ' y se evaluará en la auditoría.'"
                          :simple="true"
                        ></r-input>
                      </f7-col>
                      <f7-col style="width: 2%;padding: 0 12px;" class="padding-horizontal-half">
                        <div class="numero-regla">
                          <span style="display: inline-flex;">
                            {{ regla.numero }}
                          </span>
                        </div>
                      </f7-col>
                      <f7-col :style="'width: ' + (enModoBorrado(rform) ? '85%' : '88%') + ';padding: 0 12px;'" class="padding-horizontal-half">
                        <r-input
                          class="col-100"
                          :class="'regla-' + rform.formData.listadoCondicionesAuditoria[indexRegla].tipoRegla"
                          :form="rform"
                          :name="'listadoCondicionesAuditoria.'+indexRegla+'.textoCondicion'"
                          type="text"
                          :readonly="rform.readonly || regla.comprobada"
                          :overrideReadonly="true"
                          :clearButton="true"
                        ></r-input>
                      </f7-col>
                      <f7-col style="width: 2.3%;padding: 0 12px;" class="padding-horizontal-half">
                        <f7-link v-if="!rform.readonly" @click="duplicarReglaAuditoria(indexRegla)" icon-f7="square_fill_line_vertical_square_fill" color="green" v-tooltip="'Duplicar regla'"></f7-link>
                      </f7-col>
                    </f7-row>
                  </div>
                </f7-card>
              </Container>
            </f7-tab>
            <f7-tab id="tab-instalacion" ref="tabInstalacion" class="page-content no-padding">
              <Container v-if="tabActive == 'INSTALACION'"
                class="margin-top smooth-dnd-container"
                :class="{'container-grupo': !rform.formData.caracteristicas || !rform.formData.caracteristicas.length}"
                group-name="grupo-caracteristicas"
                @drop="onDrop(rform.formData.caracteristicas, $event)"
                :get-child-payload="getChildPayloadGrupoCaracteristicas(rform.formData.caracteristicas)"
                lock-axis="y"
                drag-handle-selector=".column-drag-handle"
              >
                <Draggable
                  v-for="(caracteristica,ic) in rform.formData.caracteristicas"
                  :key="'caracteristica-'+'-'+ic+'-'+caracteristica.nombre"
                >
                  <caracteristica
                    :onDrop="onDrop"
                    :getChildPayloadCaracteristicas="getChildPayloadCaracteristicas"
                    :tipo="caracteristica.tipo"
                    :caracteristica="caracteristica"
                    :form="rform"
                    :label="caracteristica.tipo == 'NOTA' ? 'Nota para el inspector' : caracteristica.label"
                    :name="'caracteristicas.'+ic"
                    :placeholder="caracteristica.tipo == 'NOTA' ? 'Escriba nota que aparecerá al inspector' : 'Valor por defecto'"
                    :editable="true"
                    :allCaracteristicas="rform.formData.caracteristicas"
                    @eliminar="rform.formData.caracteristicas.splice(ic,1);"
                    :key="'caracteristica-'+'-'+ic+'-'+caracteristica.nombre"
                  ></caracteristica>
                </Draggable>
              </Container>
            </f7-tab>
            <f7-tab id="tab-tomadedatos" ref="tabTomaDatos" class="page-content no-padding">
              <f7-tabs class="full-height" v-if="tabActive == 'TOMADATOS'">
                <f7-toolbar tabbar>
                  <f7-link tab-link="#tab-comprobaciones" tab-link-active @click="subTabTomaDatosActive = 'COMPROBACION'">Comprobaciones</f7-link>
                  <f7-link
                    tab-link="#tab-defectos"
                     @click="subTabTomaDatosActive = 'DEFECTOS'"
                  >Defectos</f7-link>
                  <f7-link tab-link="#tab-subformatos" v-tooltip="$t('formatos.subformatos')"  @click="subTabTomaDatosActive = 'SUBFORMATOS'">{{$t('formatos.subformatos')}}</f7-link>
                </f7-toolbar>
                <f7-tab ref="tabComprobaciones" id="tab-comprobaciones" tab-active class="page-content no-padding">
                  <f7-list accordion-list>
                    <Container
                      group-name="grupo-comprobaciones"
                      @drop="onDrop(rform.formData.comprobaciones, $event)"
                      drag-handle-selector=".column-drag-handle"
                      :get-child-payload="getChildPayloadGrupoComprobaciones(rform.formData.comprobaciones)"
                      :class="{'container-grupo': !rform.formData.comprobaciones || !rform.formData.comprobaciones.length}"
                      class="smooth-dnd-container"
                      lock-axis="y"
                    >
                      <div class="display-flex align-items-center justify-content-space-between" style="padding-right:16px;">
                        <r-input
                          floating-label
                          :label="'Editar desde intranet'"
                          :form="rform"
                          name="editarEnIntranet"
                          type="check"
                          :simple="true"
                        ></r-input>
                        <f7-button
                          v-if="!readonly"
                          v-noroles="['ENAC']"
                          small raised fill color="red"
                          icon-f7="trash"
                          @click="limpiarResultadosComprobaciones"
                        >Limpiar Resultados</f7-button>
                        <f7-button
                          small raised
                          class="margin-left"
                          :icon-f7="comprobacionesExpandidas ? 'rectangle_compress_vertical' : 'rectangle_expand_vertical'"
                          v-tooltip="comprobacionesExpandidas ? 'Contraer todo' : 'Expandir todo'"
                          @click="comprobacionesExpandidas = !comprobacionesExpandidas; switchAllComprobaciones(rform.formData.comprobaciones, comprobacionesExpandidas)"
                        ></f7-button>
                      </div>
                      <Draggable
                        v-for="(comprobacion,ic) in getComprobacionesSettingGroup(rform.formData.comprobaciones)"
                        :key="'comprobacion-' + ic"
                      >
                        <lazy-visible :min-height="48">
                          <comprobacion
                            :comprobacion="comprobacion"
                            :name="'comprobaciones.' + ic"
                            :form="rform"
                            :resultadoDefecto="comprobacion.valorInicial"
                            :formato="true"
                            :getChildPayloadComprobaciones="getChildPayloadComprobaciones"
                            @delete="deleteComprobacion(rform.formData.comprobaciones, ic, $event)"
                          ></comprobacion>
                        </lazy-visible>
                      </Draggable>
                    </Container>
                  </f7-list>
                </f7-tab>
                <f7-tab id="tab-defectos" class="page-content no-padding">
                  <template v-if="subTabTomaDatosActive == 'DEFECTOS'">
                    <div no-gap 
                      v-for="(compro, ic) in getComprobacionesDefectos(rform.formData.comprobaciones)"
                      :key="'compro-defecto-'+ic"
                      style="margin-top: 10px;"
                    >
                      <div>
                        {{ compro.codigo }} - {{ compro.nombre }}
                        <f7-link class="margin" icon-f7="plus_square_fill" v-if="!rform.readonly && rform.formData" @click="compro.defectos.push({codigo: compro.codigo + '.' + (compro.defectos.length + 1), nombre: '', categoria: 'DL'})"></f7-link>
                      </div>
                      <f7-list class="list-form" style="margin:0;">
                        <ul>
                          <Container 
                            v-if="rform && rform.formData" 
                            @drop="onDropDefectos(compro, $event)"
                            drag-handle-selector=".column-drag-handle"
                            lock-axis="y"
                          >
                            <Draggable
                              v-for="(defecto, idd) in compro.defectos"
                              :key="'compro-defecto-'+ic+'-def-'+idd"
                            >
                              <f7-row no-gap>
                                <f7-col width="5" style="padding:0;">
                                  <f7-list-input :readonly="true" label="Código" floating-label type="text" :value="defecto.codigo">
                                  </f7-list-input>
                                </f7-col>
                                <f7-col width="10" style="padding:0;">
                                  <f7-list-input :readonly="rform.readonly" label="Código visual" outline floating-label type="text" :value="defecto.codigoVisual" @change="defecto.codigoVisual =$event.target.value">
                                  </f7-list-input>
                                </f7-col>
                                <f7-col width="30" style="padding:0;">
                                  <f7-list-input :readonly="rform.readonly" label="Nombre" outline floating-label type="text" :value="defecto.nombre" @change="defecto.nombre=$event.target.value">
                                  </f7-list-input>
                                </f7-col>
                                <f7-col width="30" style="padding:0;">
                                  <f7-list-input :class="{'mandatory': !defecto.descripcion}" :readonly="rform.readonly" label="* Descripción" outline floating-label type="text" :value="defecto.descripcion" @change="defecto.descripcion=$event.target.value">
                                  </f7-list-input>
                                </f7-col>
                                <f7-col width="10" style="padding:0;">
                                  <f7-list-input :class="{'mandatory': !defecto.categoria}" :readonly="rform.readonly" label="* Categoría" outline floating-label type="select" :value="defecto.categoria" @input="defecto.categoria=$event.target.value">
                                    <option value=""></option>
                                    <option value="DL">DL</option>
                                    <option value="DG">DG</option>
                                    <option value="DMG">DMG</option>
                                  </f7-list-input>
                                </f7-col>
                                <f7-col width="10" style="padding:0;">
                                  <f7-list-input :readonly="rform.readonly" label="Plazo Corr. (días)" outline floating-label type="number" :value="defecto.plazoCorreccion" @change="defecto.plazoCorreccion=$event.target.value">
                                  </f7-list-input>
                                </f7-col>
                                <f7-col class="padding" style="margin:0;width: 20px;">
                                  <f7-link
                                    @click="$delete(compro.defectos,idd); recalculoCodigosDefectos(compro);"
                                    style="padding:0;margin:0;width: 0;"
                                    icon-f7="trash"
                                    color="red"
                                    v-if="!rform.readonly"
                                  ></f7-link>
                                </f7-col>
                                <f7-col class="padding" style="margin:0 10px 0 0;width: 20px;">
                                  <span
                                    v-if="!readonly"
                                    class="column-drag-handle cursor-move"
                                    v-tooltip="$t('common.move')"
                                  >&uarr;&darr;</span>
                                </f7-col>
                                <hr width="100%"/>
                              </f7-row>
                            </Draggable>
                          </Container>
                        </ul>
                      </f7-list>
                    </div>
                  </template>
                </f7-tab>

                <f7-tab id="tab-subformatos" class="page-content no-padding">
                  <f7-block-title>
                    {{$t('formatos.subformatos')}}
                    <f7-link v-if="!rform.readonly && rform.formData" @click="rform.formData.tabs.push({})">{{$t('formatos.add')}}</f7-link>
                  </f7-block-title>
                  <f7-card 
                    class="elevation-3 padding-vertical-half padding-right"
                    v-for="(tab, ic) in rform.formData.tabs"
                    :key="'tabs-subformato-'+ic"
                    :style="'z-index: ' + (rform.formData.tabs.length - ic*10)"
                  > 
                    <f7-card-content>
                      <f7-list class="list-form">
                        <ul>
                          <f7-row no-gap>
                            <r-input
                              class="col-25"
                              floating-label
                              :label="'Nombre Pestaña'"
                              :form="rform"
                              :name="'tabs.'+ic+'.nombre'"
                            ></r-input>
                            <r-autocomplete
                              class="col-25"
                              :dbAdapter="Formato"
                              label="Formato"
                              :form="rform"  
                              :name="'tabs.'+ic+'.formato'"
                              labelProp="nombre"
                              prefixProp="codigo"
                              :shownFields="['codigo', 'fechaDesde', 'fechaHasta', 'comprobaciones', 'caracteristicas']"
                            >
                            </r-autocomplete>
                            <r-input
                              class="col-25"
                              floating-label
                              :label="'Tipo'"
                              :form="rform"
                              type="select"
                              :name="'tabs.'+ic+'.tipo'"
                            >
                              <option value="GENERAL">General</option>
                              <option value="CUADROS">Cuadros</option>
                              <option value="TRANSFORMADORES">Transformadores</option>
                            </r-input>
                            <r-input
                              class="col-25"
                              floating-label
                              :label="'Versión'"
                              :form="rform"
                              type="number"
                              :name="'tabs.' + ic + '.version'"
                            ></r-input>
                          </f7-row>
                        </ul>
                      </f7-list>
                    </f7-card-content>
                    <f7-link
                      v-if="!rform.readonly && rform.formData"
                      @click="$delete(rform.formData.tabs, ic);"
                      class="margin-half"
                      style="position:absolute;right:0;top:0;"
                      icon-f7="trash"
                    ></f7-link>
                  </f7-card>
                  <f7-block-title>
                    {{$t('formatos.subformatos')}}
                    <f7-link v-if="!rform.readonly && rform.formData" @click="rform.formData.tabs.push({})">{{$t('formatos.add')}}</f7-link>
                  </f7-block-title>
                </f7-tab>
              </f7-tabs>
            </f7-tab>
            
            <f7-tab v-noroles="['ENAC', 'PRODUCCION']" id="tab-precargas" class="page-content no-padding">
              <!-- Precargas -->
            	<f7-card class="padding-vertical-half padding-right" style="z-index: 3000" v-if="tabActive == 'PRECARGAS'">
                <f7-block-title>
                  <div class="label-group col-100">
                    {{$t('formatos.precargas')}}
                  </div>
                </f7-block-title>
                <f7-block-title style="z-index: 30"
                  class="accordion-opposite"
                >
                  <Container 
                    v-if="$refs.rform && $refs.rform.formData" 
                    @drop="onDrop(rform.formData.precargas, $event)"
                    drag-handle-selector=".column-drag-handle"
                    lock-axis="y"
                  >
                    <Draggable
                      v-for="(precarga, ip) in rform.formData.precargas"
                      :key="'precarga-'+ip"
                    >
                      <f7-list v-if="rform.formData.precargas && rform.formData.precargas.length" accordion-list>
                        <f7-list-item accordion-item>
                          <span
                            v-if="!readonly"
                            slot="content-start"
                            class="column-drag-handle cursor-move margin-right"
                            v-tooltip="$t('common.move')"
                            >&uarr;&darr;</span
                          >
                          <input
                            slot="before-title"
                            class="nombre-precarga"
                            :value="precarga.nombre"
                            @change="precarga.nombre = $event.target.value"
                            :placeholder="$t('formatos.nombre_precarga')"
                          />
                          <f7-link
                            v-if="!readonly"
                            style="margin-top:5px; position:absolute; right: 55px; top:3px;"
                            icon-f7="plus_square_fill_on_square_fill"
                            @click="duplicarPrecarga(ip)"
                            v-tooltip="'Duplicar precarga'"
                          ></f7-link>
                          <!-- <span 
                            v-if="!readonly"
                            style="margin-top:2px; position:absolute; right: 35px; top:3px;"
                            class="column-drag-handle margin-left cursor-move col-5"
                            v-tooltip="$t('common.move')"
                          >&uarr;&darr;</span> -->
                          <f7-link
                            v-if="!readonly"
                            style="margin-top:5px; position:absolute; right: 5px; top:3px;"
                            icon-f7="minus_circle_fill"
                            color="red"
                            @click="eliminarPrecarga(ip)"
                          ></f7-link>
                          <f7-accordion-content>
                            <r-autocomplete-m2m
                              :dbAdapter="Provincia"
                              floating-label
                              :label="$t('comunidades.provincias')"
                              :form="rform"
                              :name="'precargas.'+ ip +'.provincias'"
                              labelProp="nombre"
                              idProp="codigo"
                              :lineBreak="false"
                            ></r-autocomplete-m2m>
                            <f7-block-title>
                              <div class="label-group float-left">
                                {{$t('formatos.condiciones')}}
                              </div>
                            </f7-block-title>
                            <div class="item-content" v-if="!precarga.condiciones || !precarga.condiciones.length">
                              <div class="item-inner">
                                <div class="item-cabecera">
                                  <f7-block>{{$t('formatos.noCondicionesPlantilla')}}</f7-block>
                                </div>
                              </div>
                            </div>
                            <f7-list v-if="rform.formData.precargas && rform.formData.precargas.length"
                              style="z-index: 5">
                              <f7-list-item
                                class="col-100"
                                v-for="(condicion, ic) in precarga.condiciones"
                                :key="'condiciones-'+ip+'-'+ic"
                                :style="'z-index: '+(((rform.formData.precargas.length - ip)*precarga.condiciones.length - ic)*10)"
                              >
                                <f7-row no-gap class="list list-form no-hairlines">
                                  <r-autocomplete
                                    class="col-33"
                                    label="Característica"
                                    :form="rform"  
                                    :name="'precargas.'+ip+'.condiciones.'+ic+'.nombre'"
                                    labelProp="nombre"
                                    idProp="nombre"
                                    :dbItems="getCaracteristicas(rform.formData.caracteristicas)"
                                  >
                                  </r-autocomplete>
                                  <r-input
                                    class="col-33"
                                    floating-label
                                    :label="'Operación'"
                                    :form="rform"
                                    type="select"
                                    :name="'precargas.'+ip+'.condiciones.'+ic+'.operacion'"
                                  >
                                    <option value="IGUAL">==</option>
                                    <option value="DIFERENTE">!=</option>
                                    <option value="MAYOR">&gt;</option>
                                    <option value="MENOR">&lt;</option>
                                  </r-input>
                                  <r-input
                                    class="col-33"
                                    floating-label
                                    :label="'Valor'"
                                    :form="rform"
                                    :name="'precargas.'+ip+'.condiciones.'+ic+'.valor'"
                                  ></r-input>
                                  <f7-link
                                    style="margin-top:5px; position:absolute; right: -20px; top: 16px;"
                                    icon-f7="minus_circle_fill"
                                    color="red"
                                    @click="eliminarCondicionPrecarga(ip, ic)"
                                  ></f7-link>
                                </f7-row>
                              </f7-list-item>
                            </f7-list>
                            <f7-link
                              class="margin-left margin-bottom"
                              v-if="!rform.readonly && rform.formData"
                              @click="nuevaCondicionPrecarga(precarga)"
                              style="z-index: 4"
                            >{{$t('formatos.anadirCondicion')}}</f7-link>
                            <f7-block-title><div class="label-group col-100">{{$t('formatos.valores')}}</div></f7-block-title>
                            <f7-list v-if="rform.formData.precargas && rform.formData.precargas.length" style="z-index: 3">
                              <f7-list-item
                                class="row-valores"
                                v-for="(comprobacion, iv) in precarga.valores"
                                :key="'condiciones-'+ip+'-'+iv"
                                :style="'z-index: '+(((rform.formData.precargas.length - ip)*precarga.valores.length - iv)*10)"
                              >
                                <r-autocomplete
                                  style="width: 100%;"
                                  :placeholder="$t('formatos.comprobacion')"
                                  :form="rform"  
                                  :name="'precargas.'+ip+'.valores.'+iv + '.codigo'"
                                  labelProp="codigoNombre"
                                  idProp="codigo"
                                  :dbItems="getComprobaciones(rform.formData.comprobaciones)"
                                ></r-autocomplete>
                                <div class="comprobacion-radios align-items-center display-flex" style="width: 140px;">
                                  <label
                                    v-for="rv in [
                                      { valor: 'F', color: 'green' },
                                      { valor: 'D', color: 'orange' },
                                      { valor: 'NA', color: 'gray' },
                                    ]"
                                    :key="'rvc-' + comprobacion.codigo + '-' + rv.valor"
                                    class="radio label-radio"
                                    :class="{ disabled: readonly }"
                                  >
                                    <f7-button
                                      :fill="getValorComprobacion(ip, iv) == rv.valor"
                                      raised
                                      :color="rv.color"
                                      @click="setValorComprobacion(ip, iv, rv.valor)"
                                      >{{ rv.valor }}</f7-button
                                    >
                                  </label> 
                                  <label
                                    :key="'rvc-lock'"
                                    class="radio label-radio margin-left"
                                    :class="{ disabled: readonly }"
                                  >
                                    <f7-button
                                      raised
                                      :fill="getBloqueado(ip, iv)"
                                      color="gray"
                                      @click="toggleBloqueado(ip, iv)"
                                      :icon-f7="getBloqueado(ip, iv) ? 'lock_fill' : 'lock_open_fill'"
                                      v-tooltip="getBloqueado(ip, iv) ? $t('common.bloqueado') : $t('common.desbloqueado')"
                                      ></f7-button
                                    >
                                  </label>
                                </div>
                              </f7-list-item>
                            </f7-list>
                            <f7-link
                              class="margin-left margin-bottom"
                              v-if="!rform.readonly && rform.formData"
                              @click="nuevoValorPrecarga(ip)"
                              style="z-index: 2; padding-bottom: 10em"
                            >{{$t('formatos.anadirValor')}}</f7-link>
                          </f7-accordion-content>
                        </f7-list-item>
                      </f7-list>
                    </Draggable>
                  </Container>
                </f7-block-title>
                <f7-block-title>
                  <div v-if="!rform.formData.precargas || !rform.formData.precargas.length">{{$t('formatos.mensaje_nueva_plantilla')}}</div>
                  <f7-link
                    class="margin-top"
                    v-if="!rform.readonly && rform.formData" 
                    @click="nuevaPrecarga()"
                  >
                    {{$t('formatos.nueva_precarga')}}
                  </f7-link>
                </f7-block-title>
              </f7-card>
            </f7-tab>
            
            <f7-tab id="tab-modelosinforme" class="page-content no-padding">
     	      <!-- Plantillas de informe --> 
              <f7-card class="padding-vertical-half padding-right" v-if="tabActive == 'MODELOSINFORME'" style="z-index: 3000">
                <f7-block-title><div class="label-group col-100">{{$t('formatos.modelosPlantilla')}}</div></f7-block-title>
                <f7-block-title  v-if="$refs.rform && $refs.rform.formData" style="z-index: 30"
                  class="accordion-opposite">
                  <Container 
                    v-if="$refs.rform && $refs.rform.formData" 
                    @drop="onDrop(rform.formData.plantillasInforme, $event)"
                    drag-handle-selector=".column-drag-handle"
                    lock-axis="y"
                  >
                    <Draggable
                      v-for="(plantilla, ip) in rform.formData.plantillasInforme"
                      :key="'plantilla-'+ip"
                    >
                      <f7-list v-if="rform.formData.plantillasInforme && rform.formData.plantillasInforme.length" accordion-list>
                        <f7-list-item accordion-item>
                          <span
                            v-if="!readonly"
                            slot="content-start"
                            class="column-drag-handle cursor-move margin-right"
                            v-tooltip="$t('common.move')"
                            >&uarr;&darr;</span
                          >
                          <input
                            slot="before-title"
                            class="nombre-plantilla"
                            :value="plantilla.nombre"
                            @change="plantilla.nombre = $event.target.value"
                            :placeholder="$t('formatos.nombre_plantilla')"
                          />
                          <f7-link
                            style="margin-top:5px; position:absolute; right: 30px; top:3px;"
                            icon-f7="doc_on_doc_fill"
                            color="primary"
                            @click="duplicarPlantilla(plantilla, ip)"
                            v-tooltip="'Duplicar'"
                          ></f7-link>
                          <f7-link
                            style="margin-top:5px; position:absolute; right: 5px; top:3px;"
                            icon-f7="minus_circle_fill"
                            color="red"
                            @click="eliminarPlantilla(ip)"
                            v-tooltip="'Eliminar'"
                          ></f7-link>
                          <f7-accordion-content>
                            <r-autocomplete-m2m
                              :dbAdapter="Provincia"
                              floating-label
                              :label="$t('comunidades.provincias')"
                              :form="rform"
                              :name="'plantillasInforme.'+ ip +'.provincias'"
                              labelProp="nombre"
                              idProp="codigo"
                              idFieldDetail="id"
                              :lineBreak="false"
                            ></r-autocomplete-m2m>
                            <f7-block-title>
                              <div class="label-group float-left">
                                {{$t('formatos.condiciones')}}
                              </div>
                            </f7-block-title>
                            <r-input
                              class="col-25"
                              :label="$t('formatos.tipoInspeccion')"
                              :form="rform"
                              type="select"
                              :clear-button="false"
                              :name="'plantillasInforme.'+ip+'.segundaInspeccion'"
                            >
                              <option value="">{{$t('common.any')}}</option>
                              <option value="UNO">{{$t('formatos.tipoInspeccionPrimera')}}</option>
                              <option value="DOS">{{$t('formatos.tipoInspeccionSegundas')}}</option>
                            </r-input>
                            <r-input
                              class="col-25"
                              :label="$t('formatos.resultadoInspeccion')"
                              :form="rform"
                              type="select"
                              :clear-button="false"
                              :name="'plantillasInforme.'+ip+'.inspeccionFavorable'"
                            >
                              <option value="">{{$t('common.any')}}</option>
                              <option value="FAVORABLE">{{$t('formatos.resultadoInspeccionFavorable')}}</option>
                              <option value="DESFAVORABLE">{{$t('formatos.resultadoInspeccionNoFavorable')}}</option>
                            </r-input>
                            <r-input
                              class="col-25"
                              :label="$t('formatos.calificacion')"
                              :form="rform"
                              type="select"
                              :clear-button="false"
                              :name="'plantillasInforme.'+ip+'.calificacion'"
                            >
                              <option value="">{{$t('common.any')}}</option>
                              <option value="FAVORABLE">Favorable</option>
                              <option value="FAVORABLE_CON_DEFECTOS">Favorable con defectos</option>
                              <option value="FAVORABLE_CON_REPARO">Favorable con reparo (reiteración defecto leve inspección anterior)</option>
                              <option value="DESFAVORABLE">Condicionada</option>
                              <option value="NEGATIVO">Negativa</option>
                            </r-input>
                            <r-input
                              floating-label
                              outline
                              label="Tiene defectos leves"
                              :form="rform"
                              :simple="true"
                              type="check"
                              :name="'plantillasInforme.'+ip+'.tieneDefectosLeves'"
                            ></r-input>
                            <r-input
                              floating-label
                              outline
                              label="Tiene defectos graves"
                              :form="rform"
                              :simple="true"
                              type="check"
                              :name="'plantillasInforme.'+ip+'.tieneDefectosGraves'"
                            ></r-input>
                            <r-input
                              floating-label
                              outline
                              label="Tiene defectos muy graves"
                              :form="rform"
                              :simple="true"
                              type="check"
                              :name="'plantillasInforme.'+ip+'.tieneDefectosMuyGraves'"
                            ></r-input>
                            <r-input id="selectVersion"
                              class="col-25"
                              floating-label
                              :label="$t('formatos.version')"
                              :form="rform"
                              type="select"
                              :name="'plantillasInforme.'+ip+'.version'"
                              :clearButton="false"
                            >
                              <option value="S">{{$t('formatos.versionSi')}}</option>
                              <option value="N">{{$t('formatos.versionNo')}}</option>
                            </r-input>
                            <div class="item-content" v-if="!plantilla.condiciones || !plantilla.condiciones.length">
                              <div class="item-inner">
                                <div class="item-cabecera">
                                  <f7-block>{{$t('formatos.noCondicionesPlantilla')}}</f7-block>
                                </div>
                              </div>
                            </div>
                            <f7-list v-if="rform.formData.plantillasInforme && rform.formData.plantillasInforme.length"
                              style="z-index: 3">
                              <f7-list-item
                                class="col-100"
                                v-for="(condicion, ic) in plantilla.condiciones"
                                :key="'condiciones-'+ip+'-'+ic"
                                :style="'z-index: '+(((rform.formData.plantillasInforme.length - ip)*plantilla.condiciones.length - ic)*10)"
                              >
                                <f7-row no-gap class="list list-form no-hairlines">
                                  <r-autocomplete
                                    class="col-33"
                                    label="Característica"
                                    :form="rform"  
                                    :name="'plantillasInforme.'+ip+'.condiciones.'+ic+'.nombre'"
                                    labelProp="nombre"
                                    idProp="nombre"
                                    :dbItems="getCaracteristicas(rform.formData.caracteristicas)"
                                  >
                                  </r-autocomplete>
                                  <r-input
                                    class="col-33"
                                    floating-label
                                    :label="'Operación'"
                                    :form="rform"
                                    type="select"
                                    :name="'plantillasInforme.'+ip+'.condiciones.'+ic+'.operacion'"
                                  >
                                    <option value="IGUAL">==</option>
                                    <option value="DIFERENTE">!=</option>
                                    <option value="MAYOR">&gt;</option>
                                    <option value="MENOR">&lt;</option>
                                  </r-input>
                                  <r-input
                                    class="col-33"
                                    floating-label
                                    :label="'Valor'"
                                    :form="rform"
                                    :name="'plantillasInforme.'+ip+'.condiciones.'+ic+'.valor'"
                                  ></r-input>
                                  <f7-link
                                    style="margin-top:5px; position:absolute; right: -20px; top: 16px;"
                                    icon-f7="minus_circle_fill"
                                    color="red"
                                    @click="eliminarCondicionPlantilla(ip, ic)"
                                  ></f7-link>
                                </f7-row>
                              </f7-list-item>
                            </f7-list>
                            <f7-link
                              class="margin-left margin-bottom"
                              v-if="!rform.readonly && rform.formData"
                              @click="plantilla.condiciones.push({})"
                              style="z-index: 2"
                            >{{$t('formatos.anadirCondicion')}}</f7-link>
                            <f7-row class="margin-top"
                              style="z-index: 1">
                              <div class="col-33">
                                <r-autocomplete
                                  ref="documentosPlantilla"
                                  class="col-25"
                                  floating-label
                                  :label="$t('formatos.certificado')"
                                  :form="rform"
                                  :dbItems="documentosPlantilla"
                                  :name="'plantillasInforme.'+ ip +'.certificadoPath'"
                                  labelProp="path"
                                  idProp="path"
                                ></r-autocomplete>
                              </div>
                              <div class="col-33">
                                <r-autocomplete
                                  ref="documentosPlantilla"
                                  class="col-25"
                                  floating-label
                                  :label="$t('formatos.tomaDatos')"
                                  :form="rform"
                                  :dbItems="documentosPlantilla"
                                  :name="'plantillasInforme.'+ ip +'.datosPath'"
                                  labelProp="path"
                                  idProp="path"
                                ></r-autocomplete>
                              </div>
                              <div class="col-33"></div>
                            </f7-row>
                            <f7-block-title>
                              <div class="label-group float-left">
                                {{$t('formatos.anexos')}}
                              </div>
                            </f7-block-title>
                            <div class="item-content" v-if="!plantilla.anexos || !plantilla.anexos.length">
                              <div class="item-inner">
                                <div class="item-cabecera">
                                  <f7-block>{{$t('formatos.noAnexosPlantilla')}}</f7-block>
                                </div>
                              </div>
                            </div>
                            <f7-list v-if="rform.formData.plantillasInforme && rform.formData.plantillasInforme.length"
                              style="z-index: 2">
                              <f7-list-item
                                class="item-anexo"
                                v-for="(anexo, ic) in plantilla.anexos"
                                :key="'anexo-'+ip+'-'+ic"
                                :style="'z-index: '+(((rform.formData.plantillasInforme.length - ip)*plantilla.anexos.length - ic)*10) + '; display: block;'"
                              >
                                <f7-row no-gap class="list list-form no-hairlines">
                                  <r-autocomplete
                                    ref="documentosPlantilla"
                                    class="col-30"
                                    floating-label
                                    :label="$t('formatos.anexo')"
                                    :form="rform"
                                    :dbItems="documentosPlantilla"
                                    :name="'plantillasInforme.'+ip+'.anexos.'+ic+'.anexoPath'"
                                    labelProp="path"
                                    idProp="path"
                                  ></r-autocomplete>
                                  <r-input
                                    class="col-10"
                                    floating-label
                                    :label="$t('formatos.condicionado')"
                                    :form="rform"
                                    :name="'plantillasInforme.'+ip+'.anexos.'+ic+'.condicionado'"
                                    type="check"
                                  ></r-input>
                                  <r-autocomplete
                                    v-if="rform.formData.plantillasInforme[ip]['anexos'][ic]['condicionado']"
                                    class="col-20"
                                    label="Característica"
                                    :form="rform"  
                                    :name="'plantillasInforme.'+ip+'.anexos.'+ic+'.condicion.nombre'"
                                    labelProp="nombre"
                                    idProp="nombre"
                                    :dbItems="getCaracteristicas(rform.formData.caracteristicas)"
                                  >
                                  </r-autocomplete>
                                  <r-input
                                    v-if="rform.formData.plantillasInforme[ip]['anexos'][ic]['condicionado']"
                                    class="col-20"
                                    floating-label
                                    :label="'Operación'"
                                    :form="rform"
                                    type="select"
                                    :name="'plantillasInforme.'+ip+'.anexos.'+ic+'.condicion.operacion'"
                                  >
                                    <option value="IGUAL">==</option>
                                    <option value="DIFERENTE">!=</option>
                                    <option value="MAYOR">&gt;</option>
                                    <option value="MENOR">&lt;</option>
                                  </r-input>
                                  <r-input
                                    v-if="rform.formData.plantillasInforme[ip]['anexos'][ic]['condicionado']"
                                    class="col-20"
                                    floating-label
                                    :label="'Valor'"
                                    :form="rform"
                                    :name="'plantillasInforme.'+ip+'.anexos.'+ic+'.condicion.valor'"
                                  ></r-input>
                                  <div
                                    v-if="!rform.formData.plantillasInforme[ip]['anexos'][ic]['condicionado']"
                                    class="col-60"></div>
                                  <f7-link
                                    style="margin-top:5px; position:absolute; right: -20px; top: 16px;"
                                    icon-f7="minus_circle_fill"
                                    color="red"
                                    @click="eliminarAnexoPlantilla(ip, ic)"
                                  ></f7-link>
                                </f7-row>
                              </f7-list-item>
                            </f7-list>
                            <f7-link
                              class="margin-left margin-bottom"
                              v-if="!rform.readonly && rform.formData"
                              @click="nuevoAnexo(plantilla)"
                              style="z-index: 1"
                            >{{$t('formatos.anadirAnexo')}}</f7-link>
                            <div class="last-row-item-in-accordion"></div>
                          </f7-accordion-content>
                        </f7-list-item>
                      </f7-list>
                    </Draggable>
                  </Container>
                  <div v-if="!rform.formData.plantillasInforme || !rform.formData.plantillasInforme.length">{{$t('formatos.mensaje_nueva_plantilla')}}</div>
                  <f7-link v-if="!rform.readonly && rform.formData" @click="rform.formData.plantillasInforme.push({provincias: [], condiciones: [], anexos: []})">{{$t('formatos.nueva_plantilla')}}</f7-link>
                </f7-block-title>
              </f7-card>
            </f7-tab>
          </f7-tabs>
        </div>

        <!-- Panel derecho -->
        <div v-if="tabActive == 'INSTALACION' || (tabActive == 'TOMADATOS' && subTabTomaDatosActive == 'COMPROBACION')" style="width: 250px;" class="bg-color-white full-height">
          <f7-block-title v-if="tabActive == 'INSTALACION'" class="title-right">Características</f7-block-title>
          <f7-block v-if="tabActive == 'INSTALACION'">
            <Container
              group-name="grupo-caracteristicas"
              behaviour="copy"
              :get-child-payload="getChildPayloadGrupoCaracteristicas(null)"
            >
              <Draggable>
                <f7-button :href="false" large raised class="bg-color-white margin-vertical-half">
                  <f7-icon class="icon-placeholder" f7="folder" />Grupo
                </f7-button>
              </Draggable>
            </Container>
            <Container
              group-name="caracteristicas"
              behaviour="copy"
              :get-child-payload="getChildPayloadCaracteristicas(null)"
            >
              <Draggable v-for="btn in camposCaracteristicas" :key="'btn-caracteristica-'+btn.tipo">
                <f7-button large :href="false" raised class="bg-color-white margin-vertical-half">
                  <f7-icon class="icon-placeholder" :f7="btn.icono" />
                  {{btn.nombre}}
                </f7-button>
              </Draggable>
            </Container>
          </f7-block>
          <f7-block-title v-if="tabActive == 'TOMADATOS' && subTabTomaDatosActive == 'COMPROBACION'" class="title-right">Comprobaciones</f7-block-title>
          <f7-block v-if="tabActive == 'TOMADATOS' && subTabTomaDatosActive == 'COMPROBACION'">
            <Container
              group-name="grupo-comprobaciones"
              behaviour="copy"
              :get-child-payload="getChildPayloadGrupoComprobaciones(null)"
            >
              <Draggable>
                <f7-button :href="false" large raised class="bg-color-white margin-vertical-half">
                  <f7-icon class="icon-placeholder" f7="folder" />Grupo
                </f7-button>
              </Draggable>
            </Container>
            <Container
              group-name="comprobaciones"
              behaviour="copy"
              :get-child-payload="getChildPayloadComprobaciones(null)"
            >
              <Draggable>
                <f7-button :href="false" large raised class="bg-color-white margin-vertical-half">
                  <f7-icon class="icon-placeholder" f7="checkmark_rectangle" />Comprobación
                </f7-button>
              </Draggable>
            </Container>
          </f7-block>
          <!-- <f7-block-title class="title-right">Pestañas</f7-block-title> -->
          <!-- <f7-block>
            <Container
              group-name="pestanas"
              behaviour="copy"
              :get-child-payload="getChildPayloadPestanas(null)"
            >
              <Draggable>
                <f7-button :href="false" large raised class="bg-color-white margin-vertical-half">
                  <f7-icon class="icon-placeholder" f7="checkmark_rectangle" />Genérico
                </f7-button>
              </Draggable>
              <Draggable>
                <f7-button :href="false" large raised class="bg-color-white margin-vertical-half">
                  <f7-icon class="icon-placeholder" f7="square_split_2x2" />Cuadros
                </f7-button>
              </Draggable>
              <Draggable>
                <f7-button :href="false" large raised class="bg-color-white margin-vertical-half">
                  <f7-icon class="icon-placeholder" f7="bolt" />Transformadores
                </f7-button>
              </Draggable>
            </Container>
          </f7-block> -->
        </div>
      </template>
    </r-form>
    <f7-popup class="popuppaste" ref="popuppaste" swipeToClose>
      <f7-page>
        <f7-navbar>
          <f7-nav-left></f7-nav-left>
          <f7-nav-title>
            {{$t('common.paste')}}
          </f7-nav-title>
          <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <f7-list no-hairlines-md>
          <f7-row class="list list-form no-hairlines">
            <f7-col width="100" medium="100">
              <textarea
                ref="textareaPaste"
                type="textarea"
                placeholder="Pegue aqui el contenido del portapapeles"
                @paste.prevent="paste"
              ></textarea>
            </f7-col>
          </f7-row>
        </f7-list>
      </f7-page>
    </f7-popup>
    <f7-popup class="popupimportar" ref="popupimportar" @popup:close="$refs.rformImport.clear()" swipeToClose>
      <r-form
        ref="rformImport"
        :readonly="false"
        :dbAdapter="Formato"
        :documentoAdapter="Documento"
        :beforeSave="beforeSaveImport"
        @save="onImport"
        @error="onImportError"
      >
        <template v-slot="{rform}">
          <f7-page>
            <f7-navbar>
              <f7-nav-left></f7-nav-left>
              <f7-nav-title>
                {{$t('formatos.importacionComprobaciones')}}
              </f7-nav-title>
              <f7-nav-right></f7-nav-right>
            </f7-navbar>
            <f7-list no-hairlines-md>
              <f7-row class="list list-form no-hairlines">
                <f7-col width="100" medium="100">
                  <r-files :form="rform" name="documento" :maxFiles='1' label="Importar Documento" @loadFile="loadFile" :preview="false"></r-files>
                </f7-col>
              </f7-row>
            </f7-list>
          </f7-page>
        </template>
      </r-form>
    </f7-popup>
    <PopupProbarAuditoria v-if="probarAuditoria" @close="probarAuditoria = false" :formatoOrigen="$refs.rform.formData"></PopupProbarAuditoria>

    <f7-popup :opened="popupMapeoItemEnriquecidoOpened" @popup:closed="popupMapeoItemEnriquecidoOpened = false" class="popup-mapeo-item-canonico">
      <f7-page>
        <f7-navbar title="Mapeo de item enriquecido — propuesta IA">
          <f7-nav-right>
            <f7-link popup-close>Cerrar</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <div class="mapeo-popup-content">
          <p class="text-color-gray no-margin-top">
            El agente IA analiza el formato y propone qué estrategia (MOV/FIJ/CAL/PRV) le aplica y cómo extraer cada campo requerido desde un expediente. Revisa, ajusta el JSON si quieres y confirma para guardarlo en este formato. Una vez guardado, cada expediente generará su item enriquecido instantáneamente sin volver a llamar al LLM.
          </p>
          <textarea
            v-model="mapeoItemEnriquecidoPropuesto"
            class="mapeo-textarea"
            spellcheck="false"
          ></textarea>
          <div v-if="mapeoItemEnriquecidoError" class="text-color-red mapeo-error">⚠ {{mapeoItemEnriquecidoError}}</div>
          <div class="mapeo-actions">
            <f7-button color="gray" @click="popupMapeoItemEnriquecidoOpened = false">Cancelar</f7-button>
            <f7-button fill color="green" @click="confirmarMapeoItemEnriquecido">
              <i class="f7-icons" style="font-size:16px;margin-right:6px;">checkmark_seal_fill</i>
              Confirmar y guardar en el formato
            </f7-button>
          </div>
        </div>
      </f7-page>
    </f7-popup>
  </f7-page>

</template>
<style scoped>
/* Cuadro de instrucciones para la generacion. Discreto: se usa en pruebas, no a diario. */
.instrucciones-ia {
  margin: 4px 12px 10px;
  padding: 8px 10px;
  border: 1px solid #d7dde5;
  border-radius: 6px;
  background: #fbfcfe;
}
.instrucciones-ia-titulo { font-size: 12px; font-weight: 700; color: #1a2744; margin-bottom: 6px; }
.instrucciones-ia-nota { font-weight: 400; color: #6b7a90; margin-left: 6px; }
.instrucciones-ia-texto {
  width: 100%;
  min-height: 70px;
  resize: vertical;
  border: 1px solid #d7dde5;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 13px;
  line-height: 1.4;
}
.instrucciones-ia-pie {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  color: #6b7a90;
  margin-top: 4px;
}
.instrucciones-ia-tope { color: #d1495b; font-weight: 700; }
.instrucciones-ia-alcance { font-size: 12px; color: #1a2744; margin-top: 6px; display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.instrucciones-ia-alcance select { border: 1px solid #d7dde5; border-radius: 4px; padding: 2px 6px; font-size: 12px; max-width: 320px; }
.instrucciones-ia-bloqueado { background: #f1f3f6; color: #6b7a90; cursor: not-allowed; }
/* #1001 · Aviso de formato en vigor, en la barra y junto a «Crear edición nueva». */
.aviso-formato-en-vigor {
  max-width: 420px;
  font-size: 12px;
  line-height: 1.3;
  margin-right: 8px;
  white-space: normal;
}
/* Barra del modo borrado: una sola linea, para no empujar el listado hacia abajo. */
.barra-borrado-reglas {
  align-items: center;
  gap: 8px;
  margin: 0 0 8px 12px;
  flex-wrap: wrap;
}
.filtro-borrado-reglas {
  border: 1px solid gray;
  border-radius: 5px;
  padding: 2px 8px;
  min-width: 280px;
  height: 28px;
}
.barra-borrado-reglas .button {
  width: auto !important;
  display: inline-flex;
}
/* Eliminar y su check van juntos, sin el hueco que la barra deja entre lo demas. */
.acciones-borrado-reglas {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.cuenta-borrado-reglas {
  color: gray;
  font-size: 12px;
}
/* Cronograma del barrido de generación de condiciones: una fila por sección. */
.cronograma-ia {
  margin: 0 12px 10px 12px;
  padding: 8px 10px;
  border: 1px solid rgba(0, 0, 255, 0.25);
  border-radius: 6px;
  background: rgba(0, 0, 255, 0.02);
}
.cronograma-ia-tabla {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  margin-top: 6px;
}
.cronograma-ia-tabla th {
  text-align: left;
  font-weight: 600;
  color: #555;
  border-bottom: 1px solid #ddd;
  padding: 2px 6px;
}
.cronograma-ia-tabla td {
  padding: 2px 6px;
  border-bottom: 1px solid #f0f0f0;
}
.cronograma-ia-tabla tr.crono-curso {
  background: rgba(0, 0, 255, 0.06);
  font-weight: 600;
}
.cronograma-ia-tabla tr.crono-hecha td { color: #2a7d2a; }
.cronograma-ia-tabla tr.crono-error td { color: #b00020; }
.cronograma-ia-tabla tr.crono-pendiente td,
.cronograma-ia-tabla tr.crono-cancelada td { color: #999; }

/* Anchos fijos del cronograma.
   Sin esto, una sección con nombre largo —y las hay que juntan tres áreas— estira su columna y
   empuja a la derecha estado, tiempo, reglas y coste, que dejan de estar alineados entre filas.
   Con `table-layout: fixed` los anchos los mandan estas reglas y el nombre largo se corta donde
   toca. El selector es de hijo directo a propósito: la tabla del desglose por modelo comparte
   clase y ahí sí interesa que las columnas se repartan solas. */
.cronograma-ia > .cronograma-ia-tabla {
  table-layout: fixed;
}
.cronograma-ia > .cronograma-ia-tabla .col-seccion {
  /* Sin ancho: se queda con lo que sobra. Una sola línea con puntos suspensivos, y el nombre
     completo en el tooltip, que es donde no estorba. */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cronograma-ia > .cronograma-ia-tabla .col-estado { width: 80px; }
.cronograma-ia > .cronograma-ia-tabla .col-tiempo { width: 70px; }
.cronograma-ia > .cronograma-ia-tabla .col-reglas { width: 60px; }
.cronograma-ia > .cronograma-ia-tabla .col-coste { width: 80px; }
.cronograma-ia > .cronograma-ia-tabla .col-detalle {
  width: 34%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.costes-ia {
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px dashed rgba(0, 0, 255, 0.2);
  font-size: 12px;
  color: #555;
}

.title-right {
  min-height: 17px;
}
.container-grupo {
  border: solid 2px black;
}
.menu-item-dropdown .menu-item-content:after {
  content: inherit !important;
}
.tab-link-active {
  background-color: var(--f7-theme-color-shade) !important;
}
.icon-placeholder {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.2;
  font-size: 2.8em;
  transform: rotate(-15deg);
}
[contenteditable="true"]:empty:before {
  content: attr(placeholder);
  pointer-events: none;
  display: block; /* For Firefox */
  opacity: 0.5;
  color: red;
}
.tab-link-active .item-media,
.accordion-item-opened .accordion-item-toggle .item-media {
  color: var(--f7-theme-color) !important;
}
.accordion-item {
  background-color: #f3f3f3;
}
.accordion-item-content {
  background-color: white;
}
.block-title > input {
  background: transparent;
  border: none;
  font-weight: bold;
  width: 100%;
}
.accordion-item > .item-link input {
  border: none;
  background: transparent;
  width: auto;
  width: 100%;
}
.accordion-item > .nombre-precarga,
.accordion-item > .nombre-plantilla {
  border: none;
  background: transparent;
  width: auto;
  width: 95%;
}
.accordion-item .file-container{
  display:inline-block;
  width: 150px;
}
.last-row-item-in-accordion {
  margin-bottom: 10em;
}
.bgcolor-item {
  background-color: #e9e7f3;
}

.separador-horizontal {
  width: 100%;
  height: 23px;
}

.cabecera-condiciones {
  font-weight: bold;
  display: flex;
  /* En vertical y centrado: son columnas de un 3-5%, y con el icono y la etiqueta en linea la
     etiqueta se salia y acababa escrita encima de la columna siguiente. */
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
  padding: 0 4px;
  font-size: 10px;
  line-height: 1.1;
  min-width: 0;
  text-align: center;
}
/* Freno: si aun asi no cabe, se corta con puntos suspensivos en su columna. Nunca invade la de al
   lado, que es lo que hacia ilegible la cabecera. */
.etiqueta-columna {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* La de texto no es estrecha: en horizontal y centrada en su columna. */
.cabecera-condiciones.cabecera-texto {
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  text-align: center;
  padding: 0 12px;
  font-size: 12px;
}
/* El texto del check de marcar/desmarcar. Se ve cuando hay sitio; por debajo de ese ancho se
   esconde y queda el tooltip, que dice lo mismo. */
.etiqueta-marcar-visibles {
  font-size: 11px;
  color: gray;
  white-space: nowrap;
  cursor: pointer;
}
@media (max-width: 1280px) {
  .etiqueta-marcar-visibles {
    display: none;
  }
}

/* estilo para el textarea de nuevas reglas */
div.textarea-reglas {
  height: calc(var(--f7-popup-tablet-height) - calc(calc(var(--f7-navbar-height) + var(--f7-safe-area-top))));
  overflow: hidden;
}
.textarea-reglas * {
  height: 100%;
  margin: 0;
}
.row-100 .item-content {
  width: 100%;
}
li.row-100 div.item-content, li.row-100 div.item-content * {
  width: 100% !important;
  background-color: yellow;
}

.pie-popup {
  font-size: small;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: white;
  padding: 10px;
  border-top: 1px solid #ccc;
}

.row-auto {
  height: auto;
}

ul > li.row-valores {
  justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-start;
    --f7-cols-per-row: 1;
}

ul > li.row-valores div.item-content {
  width: 100%;
}

/* Las reglas bloqueantes las pondremos en negrita */
.regla-bloqueante {
  /*font-weight: bold;*/
}
.linea-regla-bloqueante {
  /* de color rojo */
  /*border: 1px solid #4b0000;*/
  margin: 1px;
}
/* Las reglas informativas las pondremos en cursiva */
.regla-informativa {
  font-style: italic;
}

.linea-regla-informativa {
  /* de color verde */
  /*border: 1px solid #000052;*/
  margin: 1px;
}
.small-links-container {
  position: relative;
  width: 22px;
  height: 32px;
}

.link-arriba {
  position: absolute;
  top: 1px;
  left: -2px;
  z-index: 10;
}

.link-abajo {
  position: absolute;
  bottom: 1px;
  left: -2px;
  z-index: 10;
}

div.small-links-container a.link-arriba i.f7-icons, 
div.small-links-container a.link-abajo i.f7-icons {
  font-size: 12px !important;
}

.mandatory{
  background-color: rgb(255, 0, 0) !important;
}

</style>
<style>
/*
   Detalle de cómo se generó una regla. Va en el bloque global y no en el `scoped` porque
   Framework7 cuelga los diálogos del body, fuera del árbol del componente.
*/
.dialog.dialog-origen-ia {
  --f7-dialog-width: 640px;
}
/* Con `max-width` se descentraría: F7 centra el diálogo con
   `margin-left: calc(-1 * var(--f7-dialog-width) / 2)`, así que en pantalla estrecha hay que
   cambiar la variable, no recortar el ancho por fuera. */
@media (max-width: 700px) {
  .dialog.dialog-origen-ia {
    --f7-dialog-width: 92vw;
  }
}
.dialog-origen-ia .dialog-text {
  text-align: left;
  /* Alto acotado a la pantalla: el análisis de los revisores puede ser largo y sin esto el
     diálogo crece hasta comerse los botones. */
  max-height: 60vh;
  overflow-y: auto;
}

/* 
   clase para poner un pequeño botón en la esquina superior derecha de la tabla
*/
.ajustar-ancho::after {
  position:absolute;
  right: 0;
  content: '\f152';
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}
.regla-bloqueante input[type="text"] {
  color: #4b0000;
}
.regla-informativa input[type="text"] {
  color: #000052;
}

.item-anexo .item-inner {
  display: block;
  margin-right: 30px;
}

div.col > div.numero-regla {
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  align-items: center;
  padding-top: var(--f7-list-item-padding-vertical);
  padding-bottom: var(--f7-list-item-padding-vertical);
  min-height: var(--f7-list-item-min-height);
}

.expandir-tabla {
    border: 1px solid #043975;
    color: white;
    border-radius: 4px 4px 0 0;
    cursor: pointer;
    background-color: #043975;
  }

/* Opción "Sugerir mapeo de item enriquecido (IA)" en el dropdown */
.mapeo-item-canonico-beta {
  color: #ff9800 !important;
  font-weight: 600;
}
.mapeo-item-canonico-beta-tag {
  display: inline-block;
  margin-left: 4px;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #fff;
  background: #ff9800;
  border-radius: 3px;
  vertical-align: middle;
}

/* Popup propuesta de mapeo */
::v-deep .popup-mapeo-item-canonico .page-content {
  padding: 16px;
}
.mapeo-popup-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  box-sizing: border-box;
}
.mapeo-textarea {
  flex: 1 1 auto;
  min-height: 360px;
  font-family: ui-monospace, "Cascadia Code", Consolas, monospace;
  font-size: 13px;
  padding: 10px 12px;
  border: 1px solid #c5dbff;
  border-radius: 6px;
  resize: vertical;
  background: #fff;
}
.mapeo-error {
  font-size: 13px;
}
.mapeo-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  flex-wrap: wrap;
}
</style>
<script>
import Vue from "vue";
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import rRichTextInput from "./../../components/rRichTextInput.vue";
import rFiles from "./../../components/rFiles.vue";
import rAutocomplete from "./../../components/rAutocomplete.vue";
import rAutocompleteM2m from "./../../components/rAutocompleteM2m.vue";
import rTimepicker from "./../../components/rTimepicker.vue";
import Formato from "./../../js/db/Formato.js";
import ItemEnriquecido from "./../../js/db/ItemEnriquecido.js";
import Provincia from "./../../js/db/Provincia.js";
import Materia from "./../../js/db/Materia.js";
import Documento from "./../../js/db/Documento.js";
import DocumentoGestion from "./../../js/db/DocumentoGestion.js";
import rPanel from "./../../components/rPanel.vue";
import { Container, Draggable } from "vue-smooth-dnd";
import Caracteristica from "./../inspecciones/Caracteristica.vue";
import Comprobacion from "./../inspecciones/Comprobacion.vue";
import Property from "./../../js/db/Property.js";
import Utils from "./../../js/Utils.js";
import PopupProbarAuditoria from "./popup-probar-auditoria.vue"
import moment from 'moment'
import DetalleRegla from './detalle-regla.vue';
import LazyVisible from "./../../components/LazyVisible.vue";
import rIaPensando from "./../../components/rIaPensando.vue";
import GeneracionReglasEvents from "./../../js/db/GeneracionReglasEvents.js";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";
import cerrojoDeLaSesion from "./../../js/utils/cerrojoDeLaSesion.js";
import { esCancelacion } from "./../../js/utils/sesionDePeticiones.js";
import RoutesUtils from "./../../js/RoutesUtils.js";

const applyDrag = (arr, dragResult, vueSelf) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;
  console.log(arr, dragResult);
  //const result = [...arr];
  if (!arr) arr = [];
  var result = arr;

  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = Object.assign({},  result.splice(removedIndex, 1)[0]);
  }

  if (addedIndex !== null) {
    result.push(Object.assign({}, itemToAdd));
    if (vueSelf) {
      vueSelf.$nextTick(_ => {
        result.splice(addedIndex, 0, result.pop());
      })
    } else {
      result.splice(addedIndex, 0, result.pop());
    }
  }

  //return result;
};

export default {
  components: {
    rForm,
    rInput,
    rRichTextInput,
    rTimepicker,
    rFiles,
    rAutocomplete,
    rAutocompleteM2m,
    rPanel,
    Container,
    Draggable,
    Caracteristica,
    Comprobacion,
    PopupProbarAuditoria,
    DetalleRegla,
    LazyVisible,
    rIaPensando
  },
  data: function() {
    var self = this;
    return {
      Formato,
      Provincia,
      Materia,
      Documento,
      DocumentoGestion,
      Property,
      Utils,
      readonly: !this.editable,
      rPanelOpenedByBreakpoint: false,
      precargaHabilitada: false,
      comprobacionesExpandidas: false,
      camposCaracteristicas: [
        { tipo: "TEXT", nombre: "Texto", icono: "textbox" },
        { tipo: "TEXTAREA", nombre: "Texto largo", icono: "text_justifyleft" },
        { tipo: "NOTA", nombre: "Nota", icono: "plus_bubble_fill" },
        {
          tipo: "NUMBER",
          nombre: "Número",
          icono: "number"
        },
        { tipo: "CHECK", nombre: "Check SI/NO", icono: "checkmark_rectangle" },
        {
          tipo: "MULTILIST",
          nombre: "Lista de checks",
          icono: "text_badge_checkmark"
        },
        {
          tipo: "SIMPLELIST",
          nombre: "Lista de opciones",
          icono: "list_number"
        },
        { tipo: "DATE", nombre: "Fecha", icono: "calendar" },
        { tipo: "TABLA", nombre: "Tabla", icono: "table" },
        { tipo: "TABLA_PERSONALIZADA", nombre: "Tabla personalizada", icono: "table_badge_more" },
        { tipo: "FIRMA", nombre: "Firma", icono: "signature" },
        { tipo: "TRANSFORMADOR", nombre: "Transformador", icono: "battery_100" },
        { tipo: "AUTOCALCULADO", nombre: "Cálculo", icono: "equal_square" }
      ],
      nuid: 1,
      tipos: {
        certificado: 'CI',
        tomaDatos: 'HD'
      },
      formatoInicial: null,
      formato: null,
      condicionCaracteristica: {},
      documentosPlantilla: [],
      tabActive: "GENERAL",
      subTabTomaDatosActive: "COMPROBACION",
      probarAuditoria: false,
      popupMapeoItemEnriquecidoOpened: false,
      mapeoItemEnriquecidoPropuesto: "",
      mapeoItemEnriquecidoError: null,
      mapeoSugerenciaMeta: null,
      popupCondicionesAuditoriaOpened: false,
      popupReglaInfoOpened: false,
  popupMultiReglaOpened: false,
      marcadoCondicionesAuditoria: false,
      // Modo borrado de reglas. Los tres son estado de pantalla y se tiran al salir del modo; si
      // alguno acabara dentro del formato, se guardaria en el documento y ademas se confundiria con
      // `comprobada`, que ya ocupa ese sitio con otro significado.
      modoBorradoReglas: false,
      // Instrucciones para la generacion: estado de PANTALLA, no del formato. En `formData` se
      // guardarian en el documento y viajarian en cada guardado.
      //
      // `pasadaIAEsPropia` distingue la pasada que se ha lanzado desde ESTA pestaña de la que ha
      // lanzado otro: el texto de aqui solo participa en la primera.
      mostrarInstruccionesIA: false,
      pasadaIAEsPropia: false,
      // Sección concreta sobre la que generar, o '' para el barrido completo.
      seccionIA: '',
      // Las secciones elegibles. NO salen del cronograma: ese solo existe si ya se generó alguna
      // vez, y entonces un formato nuevo —justo donde más apetece probar sobre una sección— no
      // dejaría elegir ninguna. Salen de las áreas del formato, que existen desde el principio.
      seccionesDisponiblesIA: [],
      cargandoSeccionesIA: false,
      instruccionesIA: '',
      // El mismo tope que aplica el motor (AUDIT_MAX_CARACTERES_INSTRUCCIONES). Cortar aqui evita
      // escribir de mas y enterarse despues, con la pasada ya a medias.
      MAX_INSTRUCCIONES_IA: 4000,
      filtroBorradoReglas: '',
      // Guarda las REGLAS, no sus indices: con el filtro puesto las posiciones enganan.
      seleccionBorradoReglas: [],
      // Propuestas del motor de IA por número de condición: se guardan para poder enseñar
      // la etiqueta, lo que dijo cada revisor y las citas mientras se revisa.
      // Info de generación por condición, indexada por el TEXTO normalizado y no por el número:
      // `loadItem` renumera todas las condiciones al cargar el formato (regla.numero = idx + 1),
      // así que cualquier marca basada en el número —la numeración IA-n incluida— se pierde en
      // cuanto se guarda y se vuelve a entrar. El texto sí sobrevive.
      propuestasIA: {},
      generandoCondicionesIA: false,
      // Modo de parada que ha registrado el SERVIDOR: null mientras corre, 'DETENER' si se
      // conserva lo generado y 'CANCELAR' si se deshace. Llega en la narración, no se decide aquí.
      modoParadaIA: null,
      // Cuántas propuestas llevaba contadas la última narración. Cuando el servidor dice que hay
      // más de las que tenemos, se van a buscar: por SSE viaja solo el progreso.
      propuestasVistasIA: 0,
      // Evita dos consultas de propuestas solapadas cuando llegan eventos seguidos.
      trayendoPropuestasIA: false,
      // Identificador de la pasada que ya se ha resumido, para no repetir el diálogo del final
      // cada vez que llega un evento terminal (el hub reenvía el último al reconectar).
      pasadaResumidaIA: null,
      // Narración del barrido, en el formato que espera rIaPensando: {latin, texto, hechos, total}
      narracionCondicionesIA: null,
      // Una fila por sección: {clave, nombre, estado, ms, propuestas, detalle}.
      cronogramaIA: [],
      // Secciones que se procesan a la vez. Casi todo el tiempo es espera a los modelos, así que
      // subirlo baja mucho el tiempo de pared; el techo lo pone el límite de peticiones por
      // minuto de las cuentas de IA, no el navegador.
      enParaleloIA: 3,
      // Consumo y coste por modelo de esta pasada: {modelo: {llamadas, entrada, salida, costeUsd}}
      costesIA: {},
      mostrarCostesIA: false,
      // Coste acumulado de lo ya generado, que viene del cronograma guardado en servidor. Es
      // distinto de `costesIA`, que es el desglose por modelo de la pasada de ESTA sesión.
      costeAcumuladoIA: 0,
      cronogramaCompletoIA: false,
      // Quién lanzó la pasada que está corriendo. Lo dice el servidor: la pasada puede haberla
      // lanzado otra persona desde otro navegador y conviene saberlo antes de tocar nada.
      usuarioGeneracionIA: null,
      // Números de las condiciones añadidas en esta pasada, para poder deshacerlas al cancelar.
      condicionesAnadidasIA: [],
      // Propuestas que quedaron en servidor sin llegar al formato (pasada cortada).
      propuestasPendientesIA: [],
      activadoCondicionesAuditoria: true,
      showCondicionesAuditoria: false,
      showDatosGenerales: true,
      // #1001 · Vigencia del formato tal como está GUARDADO ({id, codigo, fechaDesde, versionSiguiente}).
      // No sale de formData: ahí la fecha es la que se está editando, y el API decide con la guardada.
      guardado: null,
      // Solo en una edición nueva cuyo código no se ha podido calcular (el anterior no seguía el patrón).
      codigoEdicionEditable: false,
      moment: moment
    };
  },
  props: {
    id: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    },
    version: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /** #1001 · En vigor (o ya vigente alguna vez): se cambia con una edición nueva, no en sitio. */
    enVigor() {
      return !!(this.guardado && this.guardado.id && this.fechaYaLlegada(this.guardado.fechaDesde));
    },
    puedeCrearEdicion() {
      return !!this.guardado && RoutesUtils.tieneAcceso('/formatos/version/' + this.guardado.id + '/', ['ADMIN', 'INSPECTOR']);
    },
    puedeVerEdicionSiguiente() {
      return !!this.guardado && RoutesUtils.tieneAcceso('/formatos/view/' + this.guardado.versionSiguiente + '/', ['ADMIN', 'INSPECTOR']);
    },
    /** Por qué no se puede editar y qué hacer, con la misma salida que se dibuja al lado. */
    mensajeEnVigor() {
      if (!this.enVigor) {
        return '';
      }
      const base = 'En vigor desde el ' + moment(this.guardado.fechaDesde).format('DD/MM/YYYY') + ': no se modifica, para que los informes hechos con él se puedan reconstruir.';
      if (this.guardado.versionSiguiente) {
        return base + (this.puedeVerEdicionSiguiente
          ? ' Ya tiene una edición nueva en curso: haz los cambios en esa.'
          : ' Ya tiene una edición nueva en curso; la mantiene la Dirección Técnica.');
      }
      return base + (this.puedeCrearEdicion
        ? ' Para cambiarlo, crea una edición nueva.'
        : ' Para cambiarlo, pide a la Dirección Técnica que cree una edición nueva.');
    },
    cronogramaHechas() {
      return this.cronogramaIA.filter(function (f) { return f.estado === 'hecha' || f.estado === 'error'; }).length;
    },
    cronogramaPropuestas() {
      return this.cronogramaIA.reduce(function (acc, f) { return acc + (f.propuestas || 0); }, 0);
    },
    /** Media por sección terminada; es la base de la estimación de lo que queda. */
    cronogramaMediaSegundos() {
      const hechas = this.cronogramaIA.filter(function (f) { return f.ms > 0; });
      if (!hechas.length) {
        return null;
      }
      const media = hechas.reduce(function (acc, f) { return acc + f.ms; }, 0) / hechas.length;
      return (media / 1000).toFixed(0);
    },
    /**
     * El gasto en IA solo lo ve ADMIN.
     *
     * Se resuelve con un computed y `v-if` en vez de con la directiva `v-roles`, que arranca el
     * nodo del DOM al montarlo: dentro de un `v-for` que se repinta en cada evento SSE eso deja
     * a Vue parcheando nodos que ya no están.
     */
    verCostesIA() {
      try {
        const user = JSON.parse(localStorage.getItem('user') || 'null');
        return !!(user && Array.isArray(user.roles) && user.roles.indexOf('ADMIN') > -1);
      } catch (e) {
        return false;
      }
    },
    /** Filas de coste por modelo, de la más cara a la más barata. */
    costesIAOrdenados() {
      return Object.keys(this.costesIA)
        .map(k => this.costesIA[k])
        .sort(function (a, b) { return (b.costeUsd || 0) - (a.costeUsd || 0); });
    },
    /** Coste de la pasada, sumando los dos proveedores. */
    costeTotalIA() {
      return this.costesIAOrdenados.reduce(function (acc, m) { return acc + (m.costeUsd || 0); }, 0);
    },
    /** Estimación del tiempo restante: media de lo terminado por las secciones que faltan. */
    cronogramaRestante() {
      const media = Number(this.cronogramaMediaSegundos);
      if (!media) {
        return null;
      }
      const pendientes = this.cronogramaIA.filter(function (f) { return f.estado === 'pendiente' || f.estado === 'curso'; }).length;
      if (!pendientes) {
        return null;
      }
      // Van varias secciones a la vez: lo que queda no es la suma de sus tiempos.
      const enParalelo = Math.max(1, Math.min(Number(this.enParaleloIA) || 1, pendientes));
      const segundos = (media * pendientes) / enParalelo;
      if (segundos < 90) {
        return Math.round(segundos) + 's';
      }
      const minutos = Math.round(segundos / 60);
      return minutos < 60 ? minutos + ' min' : Math.floor(minutos / 60) + 'h ' + (minutos % 60) + 'min';
    },
    hasPrecargasVisible() {
      const rform = this.$refs.rform;
      const formato = (rform && rform.formData) ? rform.formData : this.formato;
      if (!formato) return false;
      if (formato.precargas && formato.precargas.length) return true;
      if (formato.camposPersonalizados && formato.camposPersonalizados.precargas && formato.camposPersonalizados.precargas.length) return true;
      return false;
    }
  },
  beforeDestroy() {
    if (this._onGeneracionReglas) {
      GeneracionReglasEvents.unsubscribe(this._onGeneracionReglas);
      this._onGeneracionReglas = null;
    }
  },
  watch: {
    // Al pasar a solo lectura se sale del modo borrado y se tira la selección. El guardia de la
    // plantilla ya impide operar, pero dejar el estado a medias haría que al volver a "Editar"
    // reapareciera una selección vieja que el usuario ya no tiene en la cabeza.
    readonly(esSoloLectura) {
      if (esSoloLectura && this.modoBorradoReglas) {
        this.olvidarModoBorrado();
      }
    },
  },
  methods: {
    /**
     * Pide al agente IA una propuesta de mapeo {estrategia, mapeoCampos} para este formato.
     * El operador la revisa en un popup y la confirma para que se guarde en
     * `formato.itemCanonicoConfig`. Marcado BETA — solo ADMIN/DTYCAL lo ven.
     */
    sugerirMapeoItemEnriquecido() {
      const self = this;
      const formato = self.$refs.rform && self.$refs.rform.formData;
      if (!formato || !formato.id) {
        self.$f7.dialog.alert("Guarda el formato antes de pedir la sugerencia.");
        return;
      }
      // #1001 · El mapeo se guarda dentro del formato, y uno en vigor no se guarda en sitio.
      if (self.enVigor) {
        self.$f7.dialog.alert(self.mensajeEnVigor, 'Formato en vigor');
        return;
      }
      self.mapeoItemEnriquecidoError = null;
      self.mapeoItemEnriquecidoPropuesto = "// Consultando agente IA, espera unos segundos…";
      self.mapeoSugerenciaMeta = null;
      self.popupMapeoItemEnriquecidoOpened = true;

      const url = ItemEnriquecido.server_movilidad + ItemEnriquecido.prefix + ItemEnriquecido.model
                + "/sugerir-mapeo-formato/" + encodeURIComponent(formato.id);
      ItemEnriquecido.sendRequest({ url: url, method: "POST", data: {} }, false)
        .then(function(res) {
          const sugerencia = (res && res.dto) ? res.dto : res;
          self.mapeoSugerenciaMeta = sugerencia;
          self.mapeoItemEnriquecidoPropuesto = self._sugerenciaMapeoAJson(sugerencia);
        })
        .catch(function(err) {
          const msg = (err && (err.message || err.error)) || "Error llamando al agente IA";
          self.mapeoItemEnriquecidoPropuesto = "// ERROR: " + msg + "\n// Puedes cerrar el popup y reintentar.";
        });
    },
    _sugerenciaMapeoAJson(sugerencia) {
      if (!sugerencia) return "{}";
      const json = {
        estrategia: sugerencia.estrategia || "",
        mapeoCampos: sugerencia.mapeoCampos || {}
      };
      var resultado = JSON.stringify(json, null, 2);
      var notas = [];
      notas.push("// --- Informe del agente IA (no incluir al confirmar) ---");
      if (sugerencia.justificacion) notas.push("// Justificación: " + sugerencia.justificacion);
      if (sugerencia.confianza != null) notas.push("// Confianza: " + sugerencia.confianza);
      if (Array.isArray(sugerencia.advertencias) && sugerencia.advertencias.length) {
        sugerencia.advertencias.forEach(a => notas.push("// ⚠ " + a));
      }
      if (sugerencia.meta) {
        notas.push("// Modelo: " + (sugerencia.meta.model || "?") + " · duración: " + (sugerencia.meta.durationMs || "?") + "ms");
      }
      return resultado + "\n\n" + notas.join("\n");
    },
    _stripJsonComments(raw) {
      if (!raw) return "";
      const idx = raw.indexOf("// ---");
      let body = idx >= 0 ? raw.slice(0, idx) : raw;
      body = body.split("\n").filter(l => !/^\s*\/\//.test(l)).join("\n").trim();
      return body;
    },
    confirmarMapeoItemEnriquecido() {
      const self = this;
      const body = self._stripJsonComments(self.mapeoItemEnriquecidoPropuesto || "");
      var parsed;
      try {
        parsed = JSON.parse(body || "{}");
      } catch (e) {
        self.mapeoItemEnriquecidoError = "JSON inválido: " + e.message;
        return;
      }
      if (!parsed.estrategia || !parsed.mapeoCampos || typeof parsed.mapeoCampos !== "object") {
        self.mapeoItemEnriquecidoError = "Faltan campos obligatorios: estrategia y mapeoCampos.";
        return;
      }
      const formato = self.$refs.rform && self.$refs.rform.formData;
      if (!formato) {
        self.mapeoItemEnriquecidoError = "No se pudo acceder al formato actual.";
        return;
      }
      const sugerencia = self.mapeoSugerenciaMeta || {};
      const config = {
        estrategia: parsed.estrategia,
        mapeoCampos: parsed.mapeoCampos,
        fechaConfirmacion: new Date().toISOString(),
        usuarioConfirmacion: (Utils.getUser && Utils.getUser() && Utils.getUser().username) || null,
        confianzaIaOriginal: sugerencia.confianza != null ? Number(sugerencia.confianza) : null,
        justificacionIa: sugerencia.justificacion || null
      };
      self.$set(formato, "itemCanonicoConfig", config);
      self.popupMapeoItemEnriquecidoOpened = false;
      self.mapeoItemEnriquecidoError = null;
      try {
        self.$f7.toast.create({
          text: "Mapeo aplicado al formato. Pulsa Guardar para persistirlo.",
          icon: '<i class="f7-icons">checkmark_alt</i>',
          position: "center",
          closeTimeout: 2500,
          destroyOnClose: true
        }).open();
      } catch (e) { /* noop */ }
    },
    escaparHtml(texto) {
      return String(texto === undefined || texto === null ? '' : texto)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },
    /**
     * Genera con IA el conjunto de condiciones de auditoría que le faltan al formato.
     *
     * Se recorre lote a lote desde aquí en vez de en una sola petición: una pasada completa
     * son decenas de llamadas a los modelos y varios minutos, que no caben en una petición
     * HTTP. Troceando, cada llamada dura lo que dura un lote, se ve el avance y se puede
     * detener a media pasada.
     *
     * Nada se guarda: las propuestas entran en el formulario desactivadas y decide la persona.
     */
    async generarCondicionesConIA() {
      const self = this;
      const app = self.$f7;
      const formato = self.$refs.rform.formData;

      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      let info;
      try {
        const res = await Formato.lotesGeneracionCondiciones(formato.id);
        info = (res && res.data) ? res.data : res;
      } catch (error) {
        espera.cerrar();
        // #663 · Un `await` sí recibe la cancelación de cerrar sesión: no hay nada que avisar, y
        // la cuenta siguiente no tiene por qué ver el `alert` de la anterior.
        if (esCancelacion(error)) return;
        app.dialog.alert((error && error.message) ? error.message : String(error));
        return;
      }
      espera.cerrar();

      const lotes = info.lotes || [];
      if (!lotes.length) {
        app.dialog.alert('El formato no tiene estructura sobre la que generar condiciones.');
        return;
      }

      // Se relee el cronograma de servidor, que es la única fuente fiable de qué está hecho: lo
      // que hay en pantalla puede ser el rastro de una pasada que se cortó. Si no se puede leer se
      // para aquí: tirar con lo que haya en pantalla significaría, en el peor caso, recorrer y
      // pagar otra vez secciones que ya están hechas.
      try {
        await self.cargarCronogramaIA(formato, true);
      } catch (error) {
        if (esCancelacion(error)) return;
        app.dialog.alert('No se ha podido consultar qué secciones están ya generadas, así que no se '
          + 'lanza nada para no repetir trabajo ya pagado.<br><br>'
          + self.escaparHtml((error && error.message) ? error.message : String(error)),
          'Sin estado de la generación');
        return;
      }

      // Las secciones ya generadas en pasadas anteriores no se vuelven a recorrer: cada una son
      // varios minutos y del orden de un dólar, y lo que hacen ya está en el listado.
      const yaHechas = {};
      (self.cronogramaIA || []).forEach(function (f) {
        if (f.estado === 'hecha') {
          yaHechas[f.clave] = f;
        }
      });
      const porRecorrer = lotes.filter(function (l) { return !yaHechas[l.clave]; });

      // Con una sección elegida no se pasa por aquí. El servidor regenera esa sección aunque ya
      // esté hecha, así que ofrecer "rehacer desde cero" borraría el marcador de las OTRAS 23 —
      // que están hechas y pagadas— para volver a generar una sola. Se perdería el registro de
      // todo el formato por probar un trozo.
      if (!porRecorrer.length && !self.seccionIA) {
        // Se ofrece rehacer aquí mismo: decirle a alguien que reinicie el cronograma cuando no hay
        // ningún sitio donde hacerlo es dejarle sin salida con el botón bloqueado.
        app.dialog.confirm(
          'Todas las secciones de este formato ya tienen reglas generadas.<br><br>'
          + '¿Rehacerlas desde cero? Se descarta el marcador de lo hecho y se vuelven a recorrer las '
          + '<b>' + lotes.length + '</b> áreas, con su tiempo y su coste. Las condiciones que ya están '
          + 'en el listado se conservan.',
          'Todo generado',
          function () {
            const esperaReinicio = preloaderDeLaSesion(self);
            esperaReinicio.mostrar();
            Formato.reiniciarCronogramaIA(formato.id)
              .then(function () {
                esperaReinicio.cerrar();
                // El marcador ya no existe: se parte de cero también en pantalla, incluido el
                // acumulado, que era el de lo que se acaba de descartar.
                self.cronogramaIA = [];
                self.costesIA = {};
                self.costeAcumuladoIA = 0;
                self.lanzarPasadaIA(formato);
              })
              .catch(function (error) {
                esperaReinicio.cerrar();
                app.dialog.alert((error && error.message) ? error.message : String(error));
              });
          });
        return;
      }

      // Con una sección elegida, el diálogo tiene que contar ESO. El texto de abajo habla de "N
      // áreas por recorrer" y de su coste, pero el servidor va a generar una sola: quien pulsa
      // estaría aprobando un alcance y un gasto que no son los que va a haber. Y este diálogo
      // existe justamente para aprobar el gasto.
      const elegida = self.seccionIA
        ? (self.seccionesDisponiblesIA.find(function (x) { return x.clave === self.seccionIA; })
            || { nombre: self.seccionIA })
        : null;
      if (elegida) {
        const avisoSeccion = [
          'Se generarán las condiciones de auditoría de <b>una sola sección</b>:',
          '<b>' + self.escaparHtml(elegida.nombre) + '</b>',
          '',
          'El resto del formato no se toca, y esta prueba <b>no cuenta</b> como sección hecha: el',
          'barrido completo la volverá a generar cuando le toque.',
          (self.instruccionesIA && self.instruccionesIA.trim()
            ? '<br>Se aplicarán tus <b>instrucciones</b>, que prevalecen sobre las directrices.'
            : ''),
          '',
          'Nada se guarda hasta que pulses Guardar.',
        ].filter(Boolean).join('<br>');

        app.dialog.confirm(avisoSeccion, 'Generar reglas de una sección', function () {
          self.lanzarPasadaIA(formato);
        });
        return;
      }

      const aviso = [
        'Se generarán las condiciones de auditoría que <b>falten</b>, con su texto y su código,',
        'a partir de las características, las comprobaciones y la normativa aplicable.',
        '',
        '<b>' + porRecorrer.length + '</b> áreas a recorrer'
          + (lotes.length !== porRecorrer.length
            ? ' (de ' + lotes.length + '; las otras ' + (lotes.length - porRecorrer.length) + ' ya están hechas y se respetan)'
            : '')
          + ' · <b>' + (info.condicionesExistentes || 0) + '</b> condiciones ya existentes (se conservan)',
        '<b>' + (info.documentosNormativa || 0) + '</b> documentos de normativa aplicables',
        (info.documentosNormativa ? '' : '<br><b>Aviso:</b> sin normativa etiquetada, las condiciones saldrán sin cita normativa.'),
        '',
        'Puede tardar varios minutos. Nada se guarda hasta que pulses Guardar.'
      ].filter(Boolean).join('<br>');

      app.dialog.confirm(aviso, 'Generar reglas con IA', function () {
        self.lanzarPasadaIA(formato);
      });
    },
    /**
     * Lanza la pasada EN SERVIDOR y vuelve enseguida.
     *
     * Antes el barrido lo conducía esta pantalla: una petición HTTP de varios minutos por
     * sección. En producción la pasarela las cortaba y la sección salía en rojo aunque el motor
     * la hubiera terminado y guardado. Ahora la petición dura lo que tarda en arrancar el job y
     * el progreso llega por SSE, así que ni la pasarela, ni un F5, ni cerrar la pestaña la cortan.
     */
    lanzarPasadaIA(formato) {
      const self = this;
      const app = self.$f7;

      // Contadores de ESTA pasada. El acumulado del formato no se toca: viene del cronograma.
      self._anadidasPasadaIA = [];
      self.propuestasVistasIA = 0;
      self.pasadaResumidaIA = null;
      self.condicionesAnadidasIA = [];

      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      // Las propuestas que ya estaban sin resolver NO son de esta pasada: si se colaran en la
      // incorporación automática, el botón de "recuperar sin guardar" no volvería a salir y se le
      // habría quitado a alguien la decisión de descartarlas que dejó pendiente.
      //
      // La foto se pide al SERVIDOR y no se copia de la pantalla: `propuestasPendientesIA` solo se
      // llena al desplegar el panel o al entrar con el cronograma a medias, así que en el resto de
      // los casos la lista estaría vacía y las viejas se colarían como si fueran de la pasada nueva.
      // Se congelan AQUI, no dentro del `then`. Entre la foto previa y el POST hay una petición de
      // por medio, y en ese hueco se puede haber cambiado de formato: `loadItem` habría vaciado las
      // instrucciones y la sección, y la pasada del formato A saldría con lo que hubiera del B —o
      // sin nada, convirtiendo una prueba de una sección en un barrido completo de 24. El id ya
      // venía congelado por el argumento; esto es lo mismo para lo que se escribió en pantalla.
      const instruccionesLanzadas = self.instruccionesIA;
      const seccionLanzada = self.seccionIA;

      self.fotoPropuestasSinResolverIA(formato)
        .then(function () { return Formato.lanzarGeneracionReglas(formato.id, instruccionesLanzadas, seccionLanzada); })
        .then(function (res) {
          const datos = (res && res.data) ? res.data : res;
          espera.cerrar();
          // Ojo con el orden: si `lanzado` es false, `estado` es el de la pasada de OTRO, que ya
          // estaba corriendo. Apuntarla como propia haría que el pie dijera "la has lanzado tú" y,
          // peor, que el recálculo por evento la confirmara, porque compararía consigo misma.
          if (datos && datos.estado && datos.lanzado !== false) {
            // Se pinta ya, sin esperar al primer evento del canal. Y se apunta cuál es la pasada
            // lanzada desde aquí: el diálogo del final es para quien pulsó el botón, no para
            // cualquiera que entre en el formato mientras corre.
            self._pasadaPropiaIA = datos.estado.inicio;
            // Arranque optimista: el primer evento SSE la confirmara o la corregira.
            self.pasadaIAEsPropia = true;
            self.aplicarEstadoGeneracion(Object.assign({ estado: 'progreso' }, datos.estado));
          }
          if (datos && datos.estado && datos.lanzado === false) {
            // Se pinta igual —interesa ver por dónde va— pero sin apropiársela.
            self.aplicarEstadoGeneracion(Object.assign({ estado: 'progreso' }, datos.estado));
          }
          if (datos && datos.lanzado === false) {
            app.dialog.alert('Ya hay una pasada en marcha para este formato'
              + (self.usuarioGeneracionIA ? ', lanzada por <b>' + self.escaparHtml(self.usuarioGeneracionIA) + '</b>' : '')
              + '. Se está siguiendo su progreso; no se ha lanzado otra.', 'Pasada en curso');
          }
        })
        .catch(function (error) {
          espera.cerrar();
          app.dialog.alert((error && error.message) ? error.message : String(error));
        });
    },
    /**
     * Apunta qué propuestas hay sin resolver ANTES de lanzar, para no adueñarse de ellas.
     *
     * Si no se puede consultar se sigue igual, con la lista vacía: en el peor caso se incorporan
     * unas propuestas que estaban esperando decisión, que es molesto pero no destruye nada — se
     * quitan del listado sin más y siguen en servidor.
     */
    fotoPropuestasSinResolverIA(formato) {
      const self = this;
      return Formato.propuestasPendientesIA(formato.id)
        .then(function (res) {
          const datos = (res && res.data) ? res.data : res;
          self._previasSinResolverIA = (datos.propuestas || []).map(function (p) {
            return self.claveCondicionIA(p.textoCondicion);
          });
        })
        .catch(function () {
          self._previasSinResolverIA = [];
        });
    },
    /**
     * Pinta la narración que manda el servidor. Es el ÚNICO sitio que toca el cronograma
     * mientras corre una pasada: el barrido ya no lo conduce esta pantalla.
     *
     * El canal es de difusión y por él pasan las pasadas de todos los formatos, así que lo
     * primero es descartar lo que no sea del que está abierto.
     */
    aplicarEstadoGeneracion(payload) {
      const self = this;
      const formato = self.$refs.rform ? self.$refs.rform.formData : null;
      if (!payload || !formato || !formato.id || String(payload.formatoId) !== String(formato.id)) {
        return;
      }

      // Pasada distinta de la que se venía siguiendo: los contadores de pasada empiezan de cero.
      // Se recalcula en cada evento y no al lanzar: una bandera que solo se enciende se queda
      // pegada, y la siguiente pasada —aunque la lance otro— heredaria el "la has lanzado tu".
      // Es exactamente el engano que este indicador venia a quitar, por la puerta de atras.
      if (payload.inicio) {
        self.pasadaIAEsPropia = self._pasadaPropiaIA === payload.inicio;
      }

      if (payload.inicio && self._pasadaVistaIA !== payload.inicio) {
        self._pasadaVistaIA = payload.inicio;
        if (self._pasadaPropiaIA !== payload.inicio) {
          // La que se lanza desde aquí ya los deja a cero en `lanzarPasadaIA`; esto es para las
          // que solo se miran, que si no arrastran lo incorporado por la pasada anterior.
          self._anadidasPasadaIA = [];
          self.condicionesAnadidasIA = [];
          self.propuestasVistasIA = 0;
        }
      }

      const secciones = payload.secciones || [];
      if (secciones.length) {
        self.cronogramaIA = secciones.map(function (s) {
          return {
            clave: s.clave,
            nombre: s.nombre,
            estado: s.estado,
            ms: s.ms || 0,
            propuestas: s.propuestas || 0,
            detalle: s.detalle || '',
            costeUsd: s.costeUsd || 0,
          };
        });
        self.cronogramaCompletoIA = !secciones.some(function (s) {
          return s.estado === 'pendiente' || s.estado === 'curso';
        });
        // Cuántas van a la vez lo decide el servidor; aquí solo se cuenta, que es lo que usa la
        // estimación de lo que queda.
        const enCurso = secciones.filter(function (s) { return s.estado === 'curso'; }).length;
        if (enCurso) {
          self.enParaleloIA = enCurso;
        }
      }

      self.volcarCostesPasadaIA(payload.costePorModelo, payload.costeUsd);
      self.generandoCondicionesIA = !!payload.enCurso;
      self.modoParadaIA = payload.modoParada || null;
      self.usuarioGeneracionIA = payload.usuario || null;
      self.narracionCondicionesIA = payload.enCurso
        ? {
          latin: payload.latin || 'Generating',
          texto: payload.texto || '',
          hechos: payload.hechos || 0,
          total: payload.total || secciones.length
        }
        : null;

      // Hay una pasada en marcha: que se vea sin tener que desplegar nada.
      if (payload.enCurso) {
        self.showCondicionesAuditoria = true;
      }

      // Por SSE viaja SOLO el progreso: las propuestas se van a buscar cuando el contador crece.
      // Así el evento es ligero y le sirve igual a una pestaña que llega a mitad de pasada.
      if ((payload.propuestas || 0) > self.propuestasVistasIA) {
        self.traerPropuestasGeneradasIA(payload.propuestas || 0);
      }

      const terminal = payload.estado === 'fin' || payload.estado === 'error' || payload.estado === 'cancelado';
      if (terminal && self.pasadaResumidaIA !== payload.inicio) {
        // Marca de pasada ya cerrada: el evento terminal puede repetirse —el hub reenvía el
        // último del canal a quien conecta— y sin esto se volvería a traer y a resumir.
        self.pasadaResumidaIA = payload.inicio;
        const propia = self._pasadaPropiaIA === payload.inicio;
        const cancelada = payload.estado === 'cancelado' || payload.modoParada === 'CANCELAR';

        if (cancelada) {
          // La limpieza es para TODAS las pestañas, no solo para la que lanzó la pasada: esta
          // pantalla ha ido incorporando al listado lo que se generaba aunque la pasada fuera de
          // otro, y el servidor acaba de descartarlo. Si no se quitan aquí, un Guardar posterior
          // metería en el formato unas reglas que ya no existen en ningún sitio.
          const quitadas = self.quitarCondicionesAnadidasIA();
          self._anadidasPasadaIA = [];
          self.propuestasVistasIA = 0;
          if (propia) {
            self.$f7.dialog.alert('Pasada cancelada. Se han descartado <b>' + quitadas + '</b> condiciones y el '
              + 'listado ha quedado como estaba.', 'Cancelado');
          }
          return;
        }

        // La última consulta la hace cualquiera que esté mirando: es la que recoge lo de la
        // sección final y lo de cualquier sección recuperada del cronograma, cuyo contador no
        // llegó a crecer. El diálogo, en cambio, es para quien pulsó el botón aquí.
        self.traerPropuestasGeneradasIA(payload.propuestas || 0, function () {
          if (propia) {
            self.resumenPasadaIA(payload);
          }
        });
      }
    },
    /** Vuelca el desglose por modelo de la pasada en la tabla de costes. */
    volcarCostesPasadaIA(porModelo, total) {
      const self = this;
      if (!porModelo || !porModelo.length) {
        return;
      }
      const nuevo = {};
      porModelo.forEach(function (m) {
        if (!m || !m.modelo) {
          return;
        }
        nuevo[m.modelo] = {
          modelo: m.modelo,
          llamadas: m.llamadas || 0,
          entrada: m.entrada || 0,
          salida: m.salida || 0,
          cacheLectura: m.cacheLectura || 0,
          cacheEscritura: m.cacheEscritura || 0,
          costeUsd: m.costeUsd || 0,
          fuentePrecio: m.fuentePrecio,
        };
      });
      self.costesIA = nuevo;
      self.costeAcumuladoIA = total || 0;
    },
    /**
     * Trae del servidor las propuestas que todavía no están en el listado y las incorpora.
     *
     * Se hace por consulta y no por SSE a propósito: el evento lleva solo el contador, así que
     * ni engorda el canal ni se pierde nada si una pestaña se conecta a mitad de pasada.
     */
    traerPropuestasGeneradasIA(contador, alTerminar) {
      const self = this;
      const formato = self.$refs.rform ? self.$refs.rform.formData : null;
      if (!formato || !formato.id) {
        if (alTerminar) { alTerminar(); }
        return;
      }
      // Ya hay una consulta en vuelo: esta se encola detrás en vez de descartarse. Descartarla
      // dejaba sin traer las propuestas de la última sección —el evento terminal suele pisar a la
      // consulta anterior— y el resumen salía diciendo que no se propuso nada.
      if (self.trayendoPropuestasIA) {
        self._colaPropuestasIA = { contador: Math.max(contador || 0, (self._colaPropuestasIA || {}).contador || 0), alTerminar: alTerminar };
        return;
      }
      cerrojoDeLaSesion(self, 'trayendoPropuestasIA');

      Formato.propuestasPendientesIA(formato.id)
        .then(function (res) {
          const datos = (res && res.data) ? res.data : res;
          const previas = self._previasSinResolverIA || [];
          const candidatas = (datos.propuestas || []).filter(function (p) {
            return !self.textoYaEnListado(p.textoCondicion);
          });
          const nuevas = candidatas.filter(function (p) {
            return previas.indexOf(self.claveCondicionIA(p.textoCondicion)) < 0;
          });
          if (nuevas.length) {
            self.anadirCondicionesPropuestas(nuevas);
            self._anadidasPasadaIA = (self._anadidasPasadaIA || []).concat(nuevas);
          }
          self.propuestasVistasIA = contador || 0;
          // Lo incorporado deja de ofrecerse como "pasada sin guardar"; lo que venía de antes
          // sigue esperando a que alguien decida.
          self.propuestasPendientesIA = candidatas.filter(function (p) {
            return previas.indexOf(self.claveCondicionIA(p.textoCondicion)) >= 0;
          });
          self.cargarOrigenIA();
        })
        .catch(function () {
          // Si falla, el contador NO se mueve: se reintenta con el siguiente evento, y al terminar
          // quedan igualmente recuperables por el botón de propuestas sin guardar.
        })
        .then(function () {
          self.trayendoPropuestasIA = false;
          if (alTerminar) { alTerminar(); }
          // Lo que llegó mientras tanto se atiende ahora, con su propio aviso de fin.
          const encolada = self._colaPropuestasIA;
          if (encolada) {
            self._colaPropuestasIA = null;
            self.traerPropuestasGeneradasIA(encolada.contador, encolada.alTerminar);
          }
        });
    },
    /** Resumen del final de la pasada: lo que ha entrado, lo que ha costado y las incidencias. */
    resumenPasadaIA(payload) {
      const self = this;
      const app = self.$f7;
      const anadidas = self._anadidasPasadaIA || [];
      self._anadidasPasadaIA = [];

      const avisos = payload.avisos || [];
      const observaciones = payload.observaciones || [];
      if (!anadidas.length) {
        app.dialog.alert('No se ha propuesto ninguna condición nueva.'
          + (avisos.length ? '<br><br><b>Incidencias:</b><br>' + self.escaparHtml(avisos.join(' · ')) : ''));
        return;
      }

      const porConfianza = {};
      anadidas.forEach(function (p) {
        porConfianza[p.confianzaConjunta] = (porConfianza[p.confianzaConjunta] || 0) + 1;
      });

      const resumen = [
        '<b>' + anadidas.length + '</b> condiciones añadidas al listado, <b>desactivadas</b> y pendientes de revisar.',
        '',
        'Confianza: ' + Object.keys(porConfianza).map(function (k) { return k + ' ' + porConfianza[k]; }).join(' · '),
        self.verCostesIA
          ? 'Coste acumulado del formato: <b>$' + self.costeTotalIA.toFixed(4) + '</b> ('
            + self.costesIAOrdenados.map(function (m) { return m.modelo + ' $' + (m.costeUsd || 0).toFixed(4); }).join(' · ') + ')'
          : '',
        (payload.modoParada === 'DETENER') ? '<br><b>La pasada se detuvo antes de terminar; se conserva lo generado.</b>' : '',
        observaciones.length ? '<br><b>Los modelos señalan:</b><br>' + self.escaparHtml(observaciones.slice(0, 5).join(' · ')) : '',
        avisos.length ? '<br><b>Incidencias:</b><br>' + self.escaparHtml(avisos.slice(0, 5).join(' · ')) : '',
        '<br>Revísalas y pulsa Guardar para conservarlas.'
      ].filter(Boolean).join('<br>');

      app.dialog.alert(resumen, 'Generación terminada');
    },
    /**
     * ¿Está ya ese texto de condición en el listado? Con varias secciones en vuelo, dos de
     * ellas pueden proponer lo mismo sin haberse visto: el motor filtra contra lo que se le
     * manda, y lo que se le manda no incluye lo que están generando sus hermanas.
     *
     * Se compara normalizado (sin acentos, sin signos, sin mayúsculas) porque la coincidencia
     * exacta de cadena no pilla las variantes de redacción del mismo texto.
     */
    textoYaEnListado(texto) {
      const self = this;
      const formato = self.$refs.rform ? self.$refs.rform.formData : null;
      if (!texto || !formato || !formato.listadoCondicionesAuditoria) {
        return false;
      }
      const normalizar = function (t) {
        return String(t || '')
          .toLowerCase()
          .normalize('NFD').replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9 ]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      };
      const buscado = normalizar(texto);
      if (!buscado) {
        return false;
      }
      return formato.listadoCondicionesAuditoria.some(function (c) {
        return normalizar(c.textoCondicion) === buscado;
      });
    },
    /**
     * Todo lo que se le manda al modelo: nuevo + leído de caché + escrito en caché. Es la cifra
     * que hay que mirar para comparar dos modelos, porque cada uno reparte distinto entre las
     * tres columnas y quedarse solo con la primera lleva a conclusiones al revés.
     */
    entradaTotalIA(m) {
      return (m.entrada || 0) + (m.cacheLectura || 0) + (m.cacheEscritura || 0);
    },
    /**
     * Semáforo de la regla generada. El color codifica el ACUERDO entre los dos modelos, que es
     * lo que dice cuánta revisión pide cada una:
     *
     *   verde   ALTA  — los dos la propusieron y coincidieron
     *   naranja MEDIA — los dos la revisaron pero no coincidieron del todo
     *   rojo    BAJA  — solo uno de los dos la vio
     *
     * Ojo al leerlo: BAJA no significa que la regla sea mala, sino que no tiene respaldo del
     * segundo modelo y hay que mirarla con más calma. Por eso el tooltip lo explica en palabras.
     *
     * Aparte va la regla NO EJECUTABLE, que sí es un defecto y no un matiz: se marca con otro
     * icono para que no se confunda con un simple desacuerdo.
     */
    /**
     * Trae el cronograma guardado y lo pinta al abrir el formato.
     *
     * Se despliegan las condiciones si queda algo por generar —para que se vea de un vistazo que
     * el formato está a medias— y se dejan plegadas si está completo, que es el caso en que no hay
     * nada que decidir.
     */
    cargarCronogramaIA(formato, propagarFallo) {
      const self = this;
      if (!formato || !formato.id) {
        return Promise.resolve();
      }
      // Devuelve la promesa: antes de lanzar una pasada hay que poder esperarla, porque es lo que
      // dice qué secciones están hechas de verdad. La tabla que hay en pantalla puede venir de una
      // pasada anterior que se cortó y marcar como error secciones que en servidor están hechas.
      return Formato.cronogramaIA(formato.id)
        .then(function (res) {
          const datos = (res && res.data) ? res.data : res;
          const c = datos ? datos.cronograma : null;
          if (!c || !(c.secciones || []).length) {
            return;
          }
          self.cronogramaIA = c.secciones.map(function (s) {
            return {
              clave: s.clave,
              nombre: s.nombre,
              estado: s.estado,
              ms: s.ms || 0,
              propuestas: s.propuestas || 0,
              detalle: s.detalle || '',
              costeUsd: s.costeUsd || 0,
            };
          });
          self.costeAcumuladoIA = c.costeUsd || 0;
          // Desglose por modelo de TODO lo gastado en el formato, no solo de esta sesión: viene
          // del cronograma, que lo acumula sección a sección. Antes la tabla de costes salía
          // vacía al entrar en un formato ya generado, porque solo se llenaba narrando la pasada.
          self.costesIA = {};
          (c.costePorModelo || []).forEach(function (m) {
            self.$set(self.costesIA, m.modelo, {
              modelo: m.modelo,
              llamadas: m.llamadas || 0,
              entrada: m.entrada || 0,
              salida: m.salida || 0,
              cacheLectura: m.cacheLectura || 0,
              cacheEscritura: m.cacheEscritura || 0,
              costeUsd: m.costeUsd || 0,
              fuentePrecio: m.fuentePrecio,
            });
          });
          // Lo gastado en secciones anotadas sin desglose (o antes de que lo hubiera). Sin esto
          // el reparto por modelo no cuadraría con el total y parecería que falta dinero.
          //
          // Se calcula aquí en vez de fiarse de `costeSinDesglosarUsd`: las secciones generadas
          // antes de que se guardara el desglose no traen ese campo, y entonces la tabla de
          // costes desaparecía entera al recargar aunque el total estuviera a la vista.
          const desglosado = (c.costePorModelo || [])
            .reduce(function (acc, m) { return acc + (m.costeUsd || 0); }, 0);
          const sinDesglosar = (c.costeSinDesglosarUsd != null)
            ? c.costeSinDesglosarUsd
            : (c.costeUsd || 0) - desglosado;
          if (sinDesglosar > 0.000001) {
            self.$set(self.costesIA, '(sin desglose)', {
              modelo: '(sin desglose)', llamadas: 0, entrada: 0, salida: 0,
              cacheLectura: 0, cacheEscritura: 0, costeUsd: sinDesglosar,
            });
          }
          self.cronogramaCompletoIA = (c.pendientes || 0) === 0;
          // Queda trabajo: se abre para que se vea. Está completo: se deja como estaba.
          if (!self.cronogramaCompletoIA) {
            self.showCondicionesAuditoria = true;
            self.cargarOrigenIA();
            self.comprobarPropuestasPendientes();
          }
        })
        .catch(function (error) {
          // Al abrir el formato el cronograma es una ayuda para retomar, no una función crítica.
          // Pero antes de lanzar una pasada sí lo es: si no se sabe qué está hecho, se recorrería
          // todo y se pagaría otra vez. Por eso ahí se pide que el fallo se propague.
          if (propagarFallo) {
            throw error;
          }
        });
    },
    /**
     * Situación de la pasada que pueda estar corriendo AHORA en servidor.
     *
     * Se pide después del cronograma —que es lo guardado— para que lo vivo mande sobre lo
     * guardado y no al revés: si llegara antes, el cronograma de Mongo lo pisaría.
     */
    cargarEstadoGeneracion(formato) {
      const self = this;
      if (!formato || !formato.id) {
        return;
      }
      // Lo último que se oyó por el canal pinta al instante, sin esperar a la respuesta.
      self.aplicarEstadoGeneracion(GeneracionReglasEvents.ultimoDe(formato.id));

      Formato.estadoGeneracionReglas(formato.id)
        .then(function (res) {
          const datos = (res && res.data) ? res.data : res;
          if (datos && datos.estado) {
            // Siempre como 'progreso': una consulta no debe disparar el diálogo del final, que
            // es cosa de los eventos en vivo de la pasada lanzada desde aquí.
            self.aplicarEstadoGeneracion(Object.assign({ estado: 'progreso' }, datos.estado));
          }
        })
        .catch(function () {
          // Saber si hay una pasada viva es una ayuda, no una función crítica.
        });
    },
    /** Clave estable de una condición: su texto normalizado. Ver el comentario de `propuestasIA`. */
    claveCondicionIA(texto) {
      return String(texto || '').trim().toLowerCase().replace(/\s+/g, ' ');
    },
    infoOrigenIA(regla) {
      return this.propuestasIA[this.claveCondicionIA((regla || {}).textoCondicion)] || null;
    },
    reglaNoEjecutableIA(regla) {
      const p = this.infoOrigenIA(regla);
      return !!(p && p.validacion && p.validacion.valida === false);
    },
    iconoOrigenIA(regla) {
      return this.reglaNoEjecutableIA(regla) ? 'exclamationmark_triangle_fill' : 'sparkles';
    },
    colorOrigenIA(regla) {
      if (this.reglaNoEjecutableIA(regla)) {
        return 'red';
      }
      const p = this.infoOrigenIA(regla);
      if (!p) {
        return 'gray';
      }
      return { ALTA: 'green', MEDIA: 'orange', BAJA: 'red' }[p.confianzaConjunta] || 'gray';
    },
    tooltipOrigenIA(regla) {
      if (this.reglaNoEjecutableIA(regla)) {
        return 'Esta regla NO se puede ejecutar: revísala antes de activarla';
      }
      const p = this.infoOrigenIA(regla);
      if (!p) {
        return 'Generada con IA (sin detalle del acuerdo)';
      }
      const explicacion = {
        ALTA: 'los dos modelos la propusieron y coincidieron',
        MEDIA: 'los dos la revisaron, pero no coincidieron del todo',
        BAJA: 'solo uno de los dos la vio: no significa que sea mala, sino que pide más revisión'
      }[p.confianzaConjunta] || '';
      return 'Acuerdo ' + (p.confianzaConjunta || '?') + (explicacion ? ' — ' + explicacion : '')
        + '. Pulsa para ver el detalle.';
    },
    /**
     * Una regla es de la IA si el servidor tiene su ficha de generación. Antes se miraba que el
     * número empezara por "IA-", pero `loadItem` renumera las condiciones al cargar, así que ese
     * marcador se perdía al guardar y volver a entrar.
     */
    esReglaDeIA(regla) {
      return !!this.infoOrigenIA(regla);
    },
    /**
     * Trae de servidor el origen de las reglas generadas y lo indexa por texto de condición.
     *
     * Hace falta porque `propuestasIA` solo vive en la sesión en que se generaron: al guardar el
     * formato y volver a entrar se pierde, y con él la trazabilidad de cada regla.
     */
    cargarOrigenIA() {
      const self = this;
      const formato = self.$refs.rform ? self.$refs.rform.formData : null;
      if (!formato || !formato.id) {
        return;
      }
      Formato.propuestasPendientesIA(formato.id, true)
        .then(function (res) {
          const datos = (res && res.data) ? res.data : res;
          const porTexto = {};
          (datos.propuestas || []).forEach(function (p) {
            porTexto[self.claveCondicionIA(p.textoCondicion)] = p;
          });
          (formato.listadoCondicionesAuditoria || []).forEach(function (c) {
            const clave = self.claveCondicionIA(c.textoCondicion);
            if (self.propuestasIA[clave]) {
              return;
            }
            const p = porTexto[clave];
            if (p) {
              self.$set(self.propuestasIA, clave, p);
            }
          });
        })
        .catch(function () {
          // Es una comodidad para revisar, no una función crítica: si no se puede, no se enseña.
        });
    },
    /** Explica cómo se generó una regla: quién la propuso, quién la concilió y con qué acuerdo. */
    verOrigenIA(regla) {
      const self = this;
      const p = self.infoOrigenIA(regla);
      if (!p) {
        self.$f7.dialog.alert('No se ha encontrado el detalle de generación de esta regla. '
          + 'Puede que se generara antes de que se guardara esa información.', 'Sin datos');
        return;
      }

      const modelos = p.modelos || {};
      const nombreA = modelos.A || 'Modelo A';
      const nombreB = modelos.B || 'Modelo B';
      const propuso = [];
      if (p.origenA) { propuso.push(nombreA); }
      if (p.origenB) { propuso.push(nombreB); }

      const revisores = (p.revisores || []).map(function (r) { return r === 'A' ? nombreA : nombreB; });

      const explicacionConfianza = {
        ALTA: 'los dos modelos la propusieron y coincidieron en que comprueban lo mismo',
        MEDIA: 'los dos la revisaron, pero no coincidieron del todo',
        BAJA: 'solo uno de los dos la vio'
      }[p.confianzaConjunta] || '';

      const filas = [
        '<b>Propuesta por:</b> ' + (propuso.length ? propuso.join(' y ') : '(no consta)'),
        '<b>Conciliada por:</b> ' + (revisores.length ? revisores.join(' y ') : '(no consta)'),
        '<b>Etiqueta:</b> ' + (p.etiqueta || '-'),
        '<b>Acuerdo:</b> ' + (p.confianzaConjunta || '-')
          + (explicacionConfianza ? ' — ' + explicacionConfianza : ''),
      ];
      if (p.validacion && p.validacion.valida === false) {
        filas.push('<b style="color:#b00020;">Regla no ejecutable:</b> ' + self.escaparHtml(p.validacion.motivo || ''));
      } else if (p.validacion && p.validacion.comprobadaCon) {
        // Con los códigos: "2 expedientes reales" no dice cuáles, y poder abrirlos es lo que
        // permite ver por qué la regla dio lo que dio. Las propuestas antiguas no los traen.
        const codigos = Array.isArray(p.validacion.expedientes) ? p.validacion.expedientes.filter(Boolean) : [];
        filas.push('<b>Comprobada contra</b> ' + p.validacion.comprobadaCon + ' expediente(s) reales'
          + (codigos.length ? ': ' + codigos.map(c => self.escaparHtml(String(c))).join(', ') : ''));
      }
      if (p.area) {
        filas.push('<b>Sección:</b> ' + self.escaparHtml(p.area));
      }
      if ((p.analisis || []).length) {
        filas.push('<br><b>Lo que dijeron los revisores:</b><br>'
          + p.analisis.map(function (a) { return '• ' + self.escaparHtml(a); }).join('<br>'));
      }
      if ((p.alternativas || []).length) {
        filas.push('<br><b>Redacción alternativa del otro revisor:</b><br>'
          + p.alternativas.map(function (a) { return '• ' + self.escaparHtml(a.textoCondicion); }).join('<br>'));
      }

      // Se crea a mano en vez de con `alert` para poder darle clase: el diálogo por defecto son
      // 320px y aquí caben el análisis de los dos revisores y la redacción alternativa, que en
      // esa anchura salen en columna de tres palabras.
      self.$f7.dialog.create({
        title: 'Generación de ' + regla.numero,
        text: filas.join('<br>'),
        buttons: [{ text: 'OK', bold: true }],
        cssClass: 'dialog-origen-ia',
      }).open();
    },
    /**
     * Detener conserva lo generado; Cancelar deshace la pasada entera.
     * En los dos casos hay que esperar a que termine la sección en vuelo: no se puede abortar
     * una petición ya lanzada a los modelos, así que se avisa de la espera.
     */
    pararGeneracionIA(modo) {
      const self = this;
      const app = self.$f7;
      const formato = self.$refs.rform ? self.$refs.rform.formData : null;
      if (!formato || !formato.id) {
        return;
      }

      const pedirParada = function () {
        Formato.pararGeneracionReglas(formato.id, modo)
          .then(function () {
            app.toast.create({
              text: modo === 'CANCELAR'
                ? 'Cancelando: terminan las secciones en curso y se descarta lo generado.'
                : 'Se detendrá al terminar las secciones en curso. Lo generado hasta ahora se conserva.',
              closeTimeout: 4000,
              position: 'top'
            }).open();
          })
          .catch(function (error) {
            app.dialog.alert((error && error.message) ? error.message : String(error));
          });
      };

      if (modo === 'CANCELAR') {
        app.dialog.confirm(
          'Se descartarán las <b>' + self.condicionesAnadidasIA.length + '</b> condiciones generadas en esta pasada'
          + ' y el listado quedará como estaba.<br><br>Las secciones en curso tardarán un momento en terminar.',
          'Cancelar la pasada',
          pedirParada);
        return;
      }

      pedirParada();
    },
    /**
     * Quita del listado las condiciones que ha añadido esta pasada, dejándolo como estaba.
     * Se identifican por su número, que es el que se les asignó al añadirlas.
     */
    quitarCondicionesAnadidasIA() {
      const self = this;
      const formato = self.$refs.rform.formData;
      const numeros = self.condicionesAnadidasIA.slice();
      if (!numeros.length || !formato.listadoCondicionesAuditoria) {
        return 0;
      }
      const antes = formato.listadoCondicionesAuditoria.length;
      const quitadas = formato.listadoCondicionesAuditoria.filter(function (c) {
        return numeros.indexOf(String(c.numero)) >= 0;
      });
      const restantes = formato.listadoCondicionesAuditoria.filter(function (c) {
        return numeros.indexOf(String(c.numero)) < 0;
      });
      self.$set(formato, 'listadoCondicionesAuditoria', restantes);
      // Se quitan también sus fichas de generación, buscándolas por texto.
      quitadas.forEach(function (c) { self.$delete(self.propuestasIA, self.claveCondicionIA(c.textoCondicion)); });
      self.condicionesAnadidasIA = [];
      return antes - restantes.length;
    },
    alternarCondicionesAuditoria() {
      this.showCondicionesAuditoria = !this.showCondicionesAuditoria;
      if (this.showCondicionesAuditoria) {
        this.comprobarPropuestasPendientes();
        this.cargarOrigenIA();
      }
    },
    /**
     * Busca propuestas que quedaron en servidor y NO están en el formulario: eso es
     * exactamente una pasada que se cortó antes de guardar. Si están ya en el listado no se
     * ofrecen, para no dar la falsa impresión de que falta algo.
     */
    comprobarPropuestasPendientes() {
      const self = this;
      const formato = self.$refs.rform ? self.$refs.rform.formData : null;
      if (!formato || !formato.id || self.generandoCondicionesIA) {
        return;
      }

      Formato.propuestasPendientesIA(formato.id)
        .then(function (res) {
          const datos = (res && res.data) ? res.data : res;
          const existentes = (formato.listadoCondicionesAuditoria || []).map(function (c) {
            return String(c.textoCondicion || '').trim().toLowerCase();
          });
          self.propuestasPendientesIA = (datos.propuestas || []).filter(function (p) {
            return existentes.indexOf(String(p.textoCondicion || '').trim().toLowerCase()) < 0;
          });
        })
        .catch(function () {
          // Que no se puedan consultar no debe molestar: es una comodidad, no una función crítica.
          self.propuestasPendientesIA = [];
        });
    },
    recuperarPropuestasPendientes() {
      const self = this;
      const app = self.$f7;
      const formato = self.$refs.rform.formData;
      const pendientes = self.propuestasPendientesIA.slice();
      if (!pendientes.length) {
        return;
      }

      const textos = pendientes.map(function (p) { return p.textoCondicion; });
      app.actions.create({
        buttons: [[
          { text: pendientes.length + ' condiciones de una pasada anterior', label: true },
          {
            text: 'Añadirlas al listado',
            onClick: function () {
              self.anadirCondicionesPropuestas(pendientes);
              self.propuestasPendientesIA = [];
              Formato.resolverPropuestasIA(formato.id, textos, 'ACEPTADA').catch(function () {});
              app.dialog.alert('Añadidas <b>' + pendientes.length + '</b> condiciones, desactivadas y pendientes de revisar.'
                + '<br><br>Recuerda pulsar Guardar.', 'Recuperadas');
            }
          },
          {
            text: 'Descartarlas',
            color: 'red',
            onClick: function () {
              self.propuestasPendientesIA = [];
              Formato.resolverPropuestasIA(formato.id, textos, 'DESCARTADA').catch(function () {});
            }
          },
          { text: 'Cancelar' }
        ]]
      }).open();
    },
    etiquetaEstadoCrono(estado) {
      return {
        pendiente: 'pendiente',
        curso: 'en curso',
        hecha: 'hecha',
        error: 'error',
        cancelada: 'cancelada'
      }[estado] || estado;
    },
    /**
     * Añade las propuestas al listado. Se numeran con prefijo IA- para que no colisionen con
     * la numeración existente y para que su origen quede a la vista, y entran desactivadas:
     * no se evalúan hasta que alguien las revise y las active.
     */
    anadirCondicionesPropuestas(propuestas) {
      const self = this;
      const formato = self.$refs.rform.formData;
      if (!formato.listadoCondicionesAuditoria) {
        self.$set(formato, 'listadoCondicionesAuditoria', []);
      }

      let siguiente = 1;
      formato.listadoCondicionesAuditoria.forEach(function (c) {
        const m = /^IA-(\d+)$/.exec(String(c.numero || ''));
        if (m && Number(m[1]) >= siguiente) {
          siguiente = Number(m[1]) + 1;
        }
      });

      propuestas.forEach(function (p) {
        const numero = 'IA-' + siguiente++;
        const regla = p.regla || {};
        formato.listadoCondicionesAuditoria.push({
          numero: numero,
          textoCondicion: p.textoCondicion,
          comprobada: false,
          activa: false,
          tipoRegla: regla.severidad === 'INFORMATIVO' ? 'informativa' : 'bloqueante',
          evalOnSync: false,
          evalOnFinish: false,
          regla: {
            regla: regla.js || '',
            numeroRegla: numero,
            caracteristicasAfectadas: regla.caracteristicasAfectadas || [],
            comprobacionesAfectadas: regla.comprobacionesAfectadas || [],
            valoresAfectados: regla.valoresAfectados || []
          }
        });
        self.$set(self.propuestasIA, self.claveCondicionIA(p.textoCondicion), p);
        self.condicionesAnadidasIA.push(numero);
      });
    },
    getSwitchPrecargasLabel() {
      const rform = this.$refs.rform;
      const formato = (rform && rform.formData) ? rform.formData : this.formato;
      if (!formato) return '';
      if (formato.precargas && formato.precargas.length) return 'Ocultar';
      if (formato.camposPersonalizados && formato.camposPersonalizados.precargas && formato.camposPersonalizados.precargas.length) return 'Mostrar';
      return '';
    },
    toggleSwitchPrecargas(event) {
      const self = this;
      // if (event && event.stopPropagation) event.stopPropagation();
      const app = self.$f7;
      const rform = self.$refs.rform;
      const formato = (rform && rform.formData) ? rform.formData : self.formato;
      const id = (formato && formato.id) || (self.formato && self.formato.id);
      if (!id) return;
      // #1001 · Cambia lo que ve el inspector: en un formato en vigor va en una edición nueva.
      if (self.enVigor) {
        app.dialog.alert(self.mensajeEnVigor, 'Formato en vigor');
        return;
      }

      // preparar mensaje según estado actual
      const willShow = !(formato && formato.precargas && formato.precargas.length);
      const mensaje = willShow ? 'Mostrará precargas del formato.' : 'Ocultará precargas del formato.';

      app.dialog.confirm(mensaje, () => {
        // mostrar preloader
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();

        const defer = fn => {
          if (typeof window !== 'undefined' && window.requestIdleCallback) {
            try {
              window.requestIdleCallback(fn);
              return;
            } catch (e) {
              // fallthrough
            }
          }
          setTimeout(fn, 0);
        };

        Formato.switchPrecargas(id)
          .then(res => {
            const applyFormat = f => {
              // actualizamos rform.formData si existe, y mantenemos this.formato reactivo
              if (rform && rform.formData) {
                self.$set(rform, 'formData', Object.assign({}, f));
              }
              self.formato = Object.assign({}, f);

              // deferir la carga más pesada para no bloquear el hilo principal
              defer(() => {
                try {
                  self.loadItem(rform && rform.formData ? rform.formData : self.formato);
                } catch (e) {
                  console.error('Error en loadItem deferred', e);
                }
              });
            };

            if (res && res.id) {
              applyFormat(res);
            } else {
              return Formato.get(id).then(f => applyFormat(f));
            }
          })
          .catch(err => {
            if (err && err.message) app.dialog.alert(err.message); else app.dialog.alert(err);
          })
          .then(() => {
            espera.cerrar();
          });
      });
    },
    onDropDefectos(compro, ev) {
      const self = this;
      self.onDrop(compro.defectos, ev); 
      self.$nextTick(() => {
        self.recalculoCodigosDefectos(compro);
      })
    },
    recalculoCodigosDefectos(compro) {
      console.log("RECALCULO", compro.defectos);
      compro.defectos.forEach((def, idx) => {
        def.codigo = compro.codigo + "." + (idx + 1);
      });
    },
    getComprobacionesDefectos(comprobaciones) {
      let compros = [];
      const self = this;
      comprobaciones.forEach(c => {
        if (c.hijas && c.hijas.length) {
          compros = [...compros, ...this.getComprobacionesDefectos(c.hijas)];
        } else {
          if (!c.defectos) {
            self.$set(c, 'defectos', []);
          }
          compros.push(c);
        }
      });
      return compros;
    },
    typeOf(data) {
      return typeof data;
    },
    paste ($event) {
      const self = this;
      const app = self.$f7;
      app.preloader.show();

      try {
        var data = $event.clipboardData.getData('text');
        self.$refs.popuppaste.close();
        self.$refs.textareaPaste.value = "";
        var formato = JSON.parse(data);
        if (formato && formato.pantallacopy && formato.pantallacopy == 'FORMATODETALLE') {
          var formData = self.$refs.rform.formData;
          formato.id = formData.id;
          formato.versionAnterior = formData.versionAnterior;
          formato.versionSiguiente = formData.versionSiguiente;

          self.$set(self.$refs.rform,"formData",formato);
          // Lo pegado aún no está guardado: su fecha de entrada en vigor no cuenta para bloquear.
          self.loadItem(formato, true);
          app.preloader.hide();
          app.dialog.alert('Formato Pegado correctamente');
        } else {
          app.preloader.hide();
          app.dialog.alert('Lo que se quiere copiar no coincide con el destino');
        }
      } catch (e) {
        app.preloader.hide();
        app.dialog.alert('Ha habido algún error al copiar desde el portapapeles');
      }
      return false;
    },
    copy ($event) {
      const self = this;
      const app = self.$f7;
      app.preloader.show();
      const el = document.createElement('textarea');
      var formato = self.$refs.rform.formData
      formato['pantallacopy'] = 'FORMATODETALLE';
      el.value = JSON.stringify(formato);
      delete formato.pantallacopy;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      app.preloader.hide();
      app.toast
        .create({
          text: 'Formato copiado en el portapapeles',
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();

    },
    getComprobacionesSettingGroup (comprobaciones) {
      return comprobaciones.map(c => {
        c.esGrupo = true; 
        return c;
      });
    },
    deleteComprobacion(comprobaciones, ic, comprobacion) {
      var self = this;
      applyDrag(comprobaciones, {removedIndex: ic, payload: null, addedIndex: null});
    },
    exportarComprobaciones(){
      var self = this;
      var formato = self.$refs.rform.formData;
      var app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Formato.exportarComprobaciones(formato).finally(() => espera.cerrar());
    },
    importarComprobaciones(){
      var self = this;
      var app = self.$f7;
      app.popup.open(".popupimportar");
    },
    onImport: function (res) {
      var self = this;
      var app = self.$f7;
      self.$refs.popupimportar.close();
      app.preloader.hide();
      self.$refs.rform.formData.comprobaciones = res.list;
    },
    onImportError: function (e) {
      var self = this;
      var app = self.$f7;
      self.$refs.popupimportar.close();
      app.preloader.hide(); 
      // TODO mensaje error;
    },
    beforeSaveImport: function(data, resolve, reject) {
      var self = this;
      var app = self.$f7;
      var o = Object.assign({}, data);
      o.documento = Array.isArray(o.documento) ? o.documento[0] : o.documento;
      app.preloader.hide();
      resolve(o);
    },
    loadFile: function () {
      var self = this;
      var app = self.$f7;
      self.$refs.rformImport.saveItem();
      app.preloader.show();
    },
    cancelarEdicion(){
      var self = this;
      self.$refs.rform.formData = Object.assign({},self.formatoInicial);
      self.readonly = true;
    },
    beforeSaveFormato: function(data, resolve, reject) {
      var self = this;
      var app = self.$f7;
      var formData = data;
      
      formData.caracteristicas = formData.caracteristicas.map(caracteristica => self._fixOptionsCaracteristica(caracteristica));

      formData.plantillasInforme.forEach(plantilla => {
        plantilla.plantillas = [];
        if(plantilla.certificadoPath) {
          plantilla.plantillas.push({
            path: plantilla.certificadoPath,
            tipo: self.tipos.certificado
          });
        }
        if(plantilla.datosPath) {
          plantilla.plantillas.push({
            path: plantilla.datosPath,
            tipo: self.tipos.tomaDatos
          });
        }
        if(plantilla.anexos){
          plantilla.anexos.forEach(anexo => {
            anexo.anexo = {
              path: anexo.anexoPath,
              tipo: 'ANEXO'
            }
          })
        }
      });

      resolve(formData);
    },
    getCaracteristicas (caracteristicas) {
      const self = this;
      if (!caracteristicas || !caracteristicas.length) {
        return [];
      }
      var result = Object.assign([], caracteristicas);
      var hijas = caracteristicas.flatMap(c => {
        return self.getCaracteristicas(c.hijas);
      });
      return result.concat(hijas);
    },
    getComprobaciones (comprobaciones) {
      var self = this;
      if (!comprobaciones || !comprobaciones.length) {
        return [];
      }
      var result = Object.assign([], comprobaciones);
      var hijas = comprobaciones.flatMap(c => {
        c.codigoNombre = c.codigo + ' - ' + c.nombre;
        return self.getComprobaciones(c.hijas);
      });
      return result.concat(hijas);
    },
    habilitarPrecargas: function () {
      var self = this;
      var app = self.$f7;
      self.precargaHabilitada = false;
      Property.getList({filter: {nombre: 'formato.precargaHabilitado'} }).then(function(res) {
        self.precargaHabilitada = res && res.list && res.list[0] && res.list[0].valor == "true";
      }).catch(function(error) {
        if (error.message) {
          app.dialog.alert(error.message);
        } else {
          app.dialog.alert(error);
        }
      });
    },
    loadItem(formato, sinGuardar) {
      var self = this;
      // Se instala un formato nuevo (pegar, cargar una version, recargar), asi que se sale del modo
      // borrado. La seleccion guarda REFERENCIAS a las reglas del listado anterior y aqui llega
      // otro objeto: las tres llamadas a loadItem reemplazan formData justo antes, asi que lo
      // seleccionado ya no existe. Sin esto, el boton seguia anunciando "Eliminar N" y al pulsarlo
      // no quitaba nada, porque el filtro por referencia no encontraba ninguna.
      self.olvidarModoBorrado();
      // Instrucciones y sección elegida son de la pantalla y del formato que se estaba mirando. Al
      // cargar otro hay que olvidarlas: las claves de sección se repiten entre formatos de la misma
      // materia, así que una sección elegida en el formato A no daría error en el B — generaría
      // otra distinta sin decir nada. Y unas instrucciones escritas para A no tienen por qué valer.
      // OJO: solo cuando cambia el formato de verdad. `loadItem` se llama también para refrescar el
      // MISMO formato —al alternar las precargas, por ejemplo—, y borrar ahí destruiría sin avisar
      // unas instrucciones que alguien puede haber tardado en escribir, o cambiaría el alcance
      // elegido por el formato entero justo antes de lanzar.
      if (self._formatoInstruccionesIA !== formato.id) {
        self._formatoInstruccionesIA = formato.id;
        self.instruccionesIA = '';
        self.seccionIA = '';
        // También el cronograma: si el formato nuevo no tiene ninguno guardado,
        // `cargarCronogramaIA` vuelve sin tocar el array y el selector seguiría enseñando las
        // secciones del anterior. Y como las claves se repiten entre formatos de la misma materia,
        // elegir una no daría error: generaría otra cosa.
        self.cronogramaIA = [];
        self.seccionesDisponiblesIA = [];
        // Si el cuadro está abierto hay que volver a pedirlas: solo se piden al abrirlo, así que si
        // no, el selector se queda sin opciones hasta cerrarlo y abrirlo otra vez.
        if (self.mostrarInstruccionesIA) {
          self.$nextTick(function () { self.cargarSeccionesIA(); });
        }
      }
      self.cargarCronogramaIA(formato).then(function () { self.cargarEstadoGeneracion(formato); });
      self.gestionaPrecargas(formato);
      self.gestionaFicherosPlantilla(formato);
      if (!formato.tabs) {
        self.$set(formato,"tabs", []);
      }
      if (!formato.nombreCategoriasDefectos) {
        self.$set(formato,"nombreCategoriasDefectos", {});
      }
      if(formato && formato.condicionesAuditoria && (!formato.listadoCondicionesAuditoria || formato.listadoCondicionesAuditoria.length == 0)) {
        // vamos a trocear condicionesAuditoria por líneas y creamos un listado de objetos {comprobada: false, textoCondicion: linea}
        self.$set(formato, "listadoCondicionesAuditoria", formato.condicionesAuditoria.split("\n").map(linea => ({comprobada: false, textoCondicion: linea})));
      }
      if(formato.listadoCondicionesAuditoria) {
        // ahora le quitamos el número inicial a las reglas y le ponemos numeración automática (número de línea del array + 1)
        formato.listadoCondicionesAuditoria.forEach((regla, idx) => {
          regla.numero = (idx + 1);
          // si la regla ya está generada (tiene campo regla.regla) le actualizamos el campo numeroRegla con el nuevo número
          if(regla.regla) {
            regla.regla.numeroRegla = regla.numero;
          }
          // eliminamos el número inicial
          regla.textoCondicion = regla.textoCondicion.replace(/^\s*\d+\s*\.\s*/, "");
        });
      }
      if(formato.editarEnIntranet == undefined) {
        self.$set(formato, "editarEnIntranet", true);
      }

      if(formato.listadoCondicionesAuditoria && formato.listadoCondicionesAuditoria.length > 0) {
        // si aluna condición de auditoría está marcada como comprobada, marcamos el flag de marcadoCondicionesAuditoria
        self.marcadoCondicionesAuditoria = formato.listadoCondicionesAuditoria.some(regla => regla?.comprobada);
        formato.listadoCondicionesAuditoria.forEach(regla => {
          if (!regla.tipoRegla) {
            regla.tipoRegla = 'bloqueante';
          }
          if(regla.activa == undefined) {
            regla.activa = true;
          }
        });
      }
      
      self.formato = formato;
      self.$set(self.$refs.rform,"formData",formato);
      self.$set(self.$refs.rform.formData,"nuevasReglas",'');
      self.formatoInicial = JSON.parse(JSON.stringify(formato));
      // #1001 · Lo pegado o una edición recién propuesta aún no están guardados: su fecha no decide
      // si el formato está en vigor ni puede dejar la pantalla en lectura.
      if (!sinGuardar) {
        self.recordarGuardado(formato);
      }
    },
    /**
     * #1001 · Apunta cómo está guardado el formato y, si está en vigor, deja la pantalla en lectura:
     * así entrar por /formatos/edit/ o guardar con la fecha de hoy no deja un «Guardar» que el API
     * va a rechazar.
     */
    recordarGuardado(formato) {
      const self = this;
      self.guardado = formato ? {
        id: formato.id,
        codigo: formato.codigo,
        fechaDesde: formato.fechaDesde,
        versionSiguiente: formato.versionSiguiente
      } : null;
      if (self.enVigor) {
        self.readonly = true;
      }
    },
    fechaYaLlegada(fecha) {
      if (!fecha) {
        return false;
      }
      const f = new Date(Array.isArray(fecha) ? fecha[0] : fecha);
      return !isNaN(f.getTime()) && f.getTime() <= Date.now();
    },
    gestionaPrecargas(formato){
      var self = this;
      if (!formato.precargas){
        self.$set(formato,"precargas", []);
        self.$set(formato.precargas, "condiciones", []);
        self.$set(formato.precargas, "valores", []);
      }
    },
    nuevaReglaAuditoria() {
      var self = this;
      var formato = self.$refs.rform.formData;
      if (!formato.listadoCondicionesAuditoria) {
        self.$set(formato, "listadoCondicionesAuditoria", []);
      }
      var app = self.$f7;
      // Abriremos un dialogo para que el usuario introduzca la nueva regla, poniendole un número correlativo en el texto como sugerencia
      
      app.dialog.prompt(
        "Nueva regla de auditoría",
        null,
        function(regla) {
          let numeroRegla = 1;
          if(formato.listadoCondicionesAuditoria.length > 0) {
            // obtenemos el número mayor de las reglas existentes y le sumamos 1
            numeroRegla = Math.max(...formato.listadoCondicionesAuditoria.map(r => parseInt(r.numero))) + 1;
          }
          // revisamos la regla por si le han metido un número por delante
          let reglaSinNumero = regla.replace(/^\s*\d+\s*\.\s*/, "");
          formato.listadoCondicionesAuditoria.push({comprobada: false, activa:true, numero: numeroRegla, textoCondicion: reglaSinNumero, tipoRegla: 'bloqueante'});
          /* document.getElementById(".reglasAuditoria").scrollTop = document.getElementById(".reglasAuditoria").scrollHeight;*/
        }
      );
    },
    nuevaReglaAuditoriaMultiple() {
      var self = this;
      var app = self.$f7;
      var formato = self.$refs.rform.formData;
      try {
        if (!formato.listadoCondicionesAuditoria) {
          self.$set(formato, "listadoCondicionesAuditoria", []);
        }
        // Separamos las reglas por saltos de línea y si empiezan por números, se los eliminamos (\s*\d+\s*\.\s*)
        var reglas = formato.nuevasReglas.split("\n");
        let numeroRegla = 1;
        if(formato.listadoCondicionesAuditoria.length > 0) {
          // obtenemos el número mayor de las reglas existentes y le sumamos 1
          const maxNumero = formato.listadoCondicionesAuditoria.reduce((max, obj) => {
            return parseInt(obj.numero) > max ? parseInt(obj.numero) : max;
          }, -Infinity);
          numeroRegla = maxNumero + 1;
        }
        reglas.forEach(r => {
          r = r.replace(/^\s*\d+\s*[\.\s\-]\s*/, "");
          formato.listadoCondicionesAuditoria.push({comprobada: false, activa:true,numero: (numeroRegla++), textoCondicion: r, tipoRegla: 'bloqueante'});
        });
      } catch (e) {
        app.dialog.alert("Error al añadir las reglas: " + e);
      } finally {
        // Eliminamos el campo nuevasReglas del formato
        self.$set(formato, "nuevasReglas", "");
        try {self.$refs.popupMultiRegla.close();} catch (e) {console.log("Error al cerrar el popup de múltiples reglas: " + e);}
      }
    },
    /**
     * Renumera de 1 a N. Se llama después de añadir o quitar reglas: el número es la referencia
     * con la que se habla de una regla, así que no puede quedar con huecos.
     */
    renumerarReglasAuditoria(formato) {
      let n = 0;
      formato.listadoCondicionesAuditoria.forEach((regla) => {
        // Las reglas de una pasada en curso llevan un número "IA-n" que NO es decorativo: es su
        // identidad mientras la pasada vive. `condicionesAnadidasIA` las apunta por ese valor y es
        // como se deshacen al cancelar. Renumerarlas las volvía enteros corrientes, y entonces
        // `quitarCondicionesAnadidasIA` ya no las encontraba: al cancelar se quedaban en el listado
        // pese a que el servidor las había descartado, y un guardado posterior las persistía.
        if (String(regla.numero || '').indexOf('IA-') === 0) {
          return;
        }
        n += 1;
        regla.numero = n;
        if(regla.regla) {
          regla.regla.numeroRegla = regla.numero;
        }
      });
    },
    /**
     * Si el modo borrado está de verdad activo.
     *
     * En solo lectura no lo está, pase lo que pase: se puede entrar en el modo y pulsar después
     * "Ver", y sin esto la barra y las casillas seguían vivas y se podían borrar reglas con el
     * resto del formulario bloqueado.
     */
    enModoBorrado(rform) {
      return this.modoBorradoReglas && !(rform && rform.readonly);
    },
    /**
     * Entra o sale del modo borrado.
     *
     * Al salir se tira la selección y el filtro: son estado de la pantalla, no del formato. Esa es
     * justo la diferencia con `comprobada`, que se guarda y significa "regla ya revisada".
     */
    /**
     * Abre o cierra el cuadro de instrucciones, y la primera vez que se abre trae las secciones.
     *
     * Se piden aquí y no al entrar en el formato porque son una petición al motor que la inmensa
     * mayoría de las visitas no necesita: el cuadro se usa para pruebas puntuales.
     */
    alternarInstruccionesIA() {
      this.mostrarInstruccionesIA = !this.mostrarInstruccionesIA;
      if (this.mostrarInstruccionesIA) {
        this.cargarSeccionesIA();
      }
    },
    /**
     * Trae las secciones elegibles del formato que hay cargado.
     *
     * Está aparte de `alternarInstruccionesIA` porque hay dos momentos en que hacen falta: al abrir
     * el cuadro, y al cargar otro formato con el cuadro YA abierto. Sin lo segundo, cambiar de
     * formato dejaba el selector con "todas las secciones" y sin opciones hasta cerrarlo y volverlo
     * a abrir, sin ninguna pista de por qué.
     */
    cargarSeccionesIA() {
      const self = this;
      if (self.seccionesDisponiblesIA.length || self.cargandoSeccionesIA) {
        return;
      }
      const formato = self.$refs.rform ? self.$refs.rform.formData : null;
      if (!formato || !formato.id) {
        return;
      }
      const idPedido = formato.id;
      let descartada = false;
      cerrojoDeLaSesion(self, 'cargandoSeccionesIA');
      Formato.lotesGeneracionCondiciones(formato.id)
        .then(function (res) {
          const datos = (res && res.data) ? res.data : res;
          // Si mientras llegaba la respuesta se ha cambiado de formato, se descarta: si no, el
          // selector acabaría ofreciendo las secciones del formato anterior, que es el mismo
          // enredo que se evita vaciando el cronograma al cargar.
          const actual = self.$refs.rform ? self.$refs.rform.formData : null;
          if (!actual || actual.id !== idPedido) {
            // Se ha cambiado de formato mientras llegaba. Hay que PEDIRLAS DE NUEVO, no solo
            // descartar: el intento que se lanzó al cargar el formato nuevo se encontró la bandera
            // de "cargando" puesta y se fue sin hacer nada, así que si aquí no se reintenta el
            // selector se queda vacío hasta que alguien cierre y abra el cuadro.
            descartada = true;
            return;
          }
          self.seccionesDisponiblesIA = ((datos && datos.lotes) || []).map(function (l) {
            return { clave: l.clave, nombre: l.nombre };
          });
        })
        .catch(function () {
          // Sin secciones se puede seguir generando el formato entero: no merece un diálogo.
          self.seccionesDisponiblesIA = [];
        })
        .then(function () {
          self.cargandoSeccionesIA = false;
          if (descartada && self.mostrarInstruccionesIA) {
            self.cargarSeccionesIA();
          }
        });
    },
    alternarModoBorradoReglas() {
      const self = this;
      const entrando = !self.modoBorradoReglas;
      self.olvidarModoBorrado();
      self.modoBorradoReglas = entrando;
    },
    /** Sale del modo borrado y tira selección y filtro. Todo esto es estado de pantalla. */
    olvidarModoBorrado() {
      this.modoBorradoReglas = false;
      this.seleccionBorradoReglas = [];
      this.filtroBorradoReglas = '';
    },
    /**
     * Las seleccionadas que SIGUEN en el listado.
     *
     * La selección guarda referencias, y el formato se reemplaza por un objeto nuevo desde varias
     * vías —pegar, cargar una versión, recargar, guardar—; cada una deja referencias huérfanas. El
     * borrado nunca se equivocó (filtra por referencia, y una huérfana no está en la lista), pero
     * el botón sí: anunciaba "Eliminar N" contando las que ya no existían. Contando solo las
     * vigentes, el botón no puede prometer más de lo que va a borrar, venga de donde venga el
     * reemplazo. Los olvidos explícitos siguen estando; esto es la red por debajo.
     */
    seleccionadasVigentes(rform) {
      const lista = (rform && rform.formData && rform.formData.listadoCondicionesAuditoria) || [];
      return this.seleccionBorradoReglas.filter(regla => lista.indexOf(regla) !== -1);
    },
    /**
     * Las reglas que hay que pintar, con su índice REAL dentro del formato.
     *
     * El índice viaja con cada fila porque los `r-input` del listado escriben por ruta
     * (`listadoCondicionesAuditoria.<i>.textoCondicion`): con el filtro puesto, el orden de pintado
     * ya no coincide con el del array y usar la posición de la lista visible escribiría en otra
     * regla.
     *
     * Es un método y no un `computed` porque el formato llega por el slot del formulario y un
     * `computed` no lo ve.
     */
    reglasVisiblesAuditoria(rform) {
      const self = this;
      const formato = rform ? rform.formData : null;
      const reglas = (formato && formato.listadoCondicionesAuditoria) || [];
      const todas = reglas.map((regla, indexRegla) => ({ regla, indexRegla }));
      const filtro = self.modoBorradoReglas ? String(self.filtroBorradoReglas || '').trim().toLowerCase() : '';
      if (!filtro) {
        return todas;
      }
      // Se busca también en el código de la regla: las generadas se parecen mucho entre sí en el
      // texto, y muchas veces lo que las agrupa de verdad es a qué comprobación miran.
      return todas.filter(function (fila) {
        const texto = String(fila.regla.textoCondicion || '').toLowerCase();
        const codigo = String((fila.regla.regla && fila.regla.regla.regla) || '').toLowerCase();
        return texto.indexOf(filtro) !== -1 || codigo.indexOf(filtro) !== -1;
      });
    },
    estaSeleccionadaParaBorrar(regla) {
      return this.seleccionBorradoReglas.indexOf(regla) !== -1;
    },
    alternarSeleccionBorrado(regla) {
      const self = this;
      const i = self.seleccionBorradoReglas.indexOf(regla);
      if (i === -1) {
        self.seleccionBorradoReglas.push(regla);
      } else {
        self.seleccionBorradoReglas.splice(i, 1);
      }
    },
    /** Si todo lo que se está viendo está ya marcado. Con el listado vacío, no. */
    todasVisiblesSeleccionadas(rform) {
      const self = this;
      const visibles = self.reglasVisiblesAuditoria(rform);
      return visibles.length > 0 && visibles.every(fila => self.estaSeleccionadaParaBorrar(fila.regla));
    },
    /**
     * Marca o desmarca lo que se está viendo, no el listado entero: con el filtro puesto, "todas"
     * tiene que querer decir "todas estas". Un "todas" que ignorara el filtro sería un borrado
     * accidental esperando a ocurrir.
     *
     * Suma y resta sobre lo ya marcado en vez de reemplazarlo, que es lo que permite ir por
     * familias: filtrar "fecha" y marcarlas, luego filtrar "alumbrado" y marcar esas también, y
     * borrarlo todo de una vez. Reemplazando, el primer grupo se habría perdido en silencio.
     */
    alternarSeleccionVisibles(rform) {
      const self = this;
      const visibles = self.reglasVisiblesAuditoria(rform).map(fila => fila.regla);
      if (self.todasVisiblesSeleccionadas(rform)) {
        self.seleccionBorradoReglas = self.seleccionBorradoReglas.filter(regla => visibles.indexOf(regla) === -1);
        return;
      }
      visibles.forEach(function (regla) {
        if (!self.estaSeleccionadaParaBorrar(regla)) {
          self.seleccionBorradoReglas.push(regla);
        }
      });
    },
    /**
     * Borra de una vez las seleccionadas.
     *
     * Se quitan por REFERENCIA y no por índice: entre seleccionar y confirmar puede haber entrado
     * una pasada de generación y haber movido las posiciones, y con índices se borrarían reglas que
     * nadie eligió. Y un solo repintado al final, que es lo que hace que con cientos de reglas esto
     * sea instantáneo y borrarlas de una en una no lo fuera.
     */
    borrarReglasSeleccionadas() {
      const self = this;
      const app = self.$f7;
      const formato = self.$refs.rform.formData;
      // Las vigentes, no las apuntadas: si el formato se reemplazo por otra via, lo que quedo
      // colgando no se va a borrar, asi que tampoco se anuncia.
      const seleccionadas = self.seleccionadasVigentes(self.$refs.rform);
      if (!seleccionadas.length) {
        return;
      }
      app.dialog.confirm('¿Seguro que quieres eliminar <b>' + seleccionadas.length + '</b> regla(s)? '
        + 'Las demás se quedan como están.', 'Eliminar reglas', function () {
        formato.listadoCondicionesAuditoria = formato.listadoCondicionesAuditoria
          .filter(regla => seleccionadas.indexOf(regla) === -1);
        self.renumerarReglasAuditoria(formato);
        self.seleccionBorradoReglas = [];
        self.filtroBorradoReglas = '';
        self.modoBorradoReglas = false;
      });
    },
    duplicarReglaAuditoria(index) {
      const self = this;
      const formato = self.$refs.rform.formData;
      let original = formato.listadoCondicionesAuditoria[index];
      let copia = JSON.parse(JSON.stringify(original));
      // en la copia vamos a quitar el flag de comprobada y le vamos a poner el número siguiente al máximo de los existentes
      copia.comprobada = false;
      copia.numero = Math.max(...formato.listadoCondicionesAuditoria.map(r => parseInt(r.numero))) + 1;
      // añadimos la copia detrás de la regla original en formato.listadoCondicionesAuditoria
      formato.listadoCondicionesAuditoria.splice(index + 1, 0, copia);
      self.renumerarReglasAuditoria(formato);
    },
    marcarDesmarcarCondicionesAuditoria() {
      var self = this;
      var formato = self.$refs.rform.formData;
      formato.listadoCondicionesAuditoria.forEach(regla => regla.comprobada = self.marcadoCondicionesAuditoria);
      self.marcadoCondicionesAuditoria = !self.marcadoCondicionesAuditoria;
    },
    activarDesactivarTodasCondicionesAuditoria() {
      var self = this;
      var formato = self.$refs.rform.formData;
      formato.listadoCondicionesAuditoria.forEach(regla => regla.activa = self.activadoCondicionesAuditoria);
      self.activadoCondicionesAuditoria = !self.activadoCondicionesAuditoria;
    },
    verReglasAuditoriaComoTexto() {
      const self = this;
      const app = self.$f7;
      let formato = self.$refs.rform.formData;
      let texto = formato.listadoCondicionesAuditoria.map(regla => regla.numero + '. ' + regla.textoCondicion).join("<br/>\n");
      self.$set(self.$refs.rform.formData, "condicionesAuditoriaTexto", texto);
      self.$set(self,"popupCondicionesAuditoriaOpened", true);
    },
    detalleReglaAuditoria(index) {
      const self = this;
      const app = self.$f7;
      let formato = self.$refs.rform.formData;
      let reglaSeleccionada = formato.listadoCondicionesAuditoria[index];
      if (!reglaSeleccionada) {
        app.dialog.alert("No se ha encontrado la regla seleccionada");
        return;
      }
      if(!reglaSeleccionada.regla) {
        reglaSeleccionada.regla = {
          regla: '',
          caracteristicasAfectadas : [ ],
          comprobacionesAfectadas : [ ],
          valoresAfectados : [],
          numeroRegla : index + ''
        };
      }
      self.$set(self.$refs.rform.formData, "reglaSeleccionada", reglaSeleccionada);
      self.$set(self,"popupReglaInfoOpened", true);
    },
    copiarAlPortapapeles(textoACopiar) {
      const self = this;
      const app = self.$f7;
      navigator.clipboard.writeText(textoACopiar)
          .then(() => {
            app.dialog.alert('Texto copiado al portapapeles');
            try {self.$refs.popupCondicionesAuditoriaTexto.close();} catch (e) {console.log("Error al cerrar el popup de texto de condiciones de auditoría: " + e);}
          })
          .catch(err => {
            console.error('Error al copiar el texto: ', err);
          });
    },
    nuevaPrecarga(){
      var self = this;
      var form = self.$refs.rform.formData;
      var nuevaPrecarga = {};
      self.$set(nuevaPrecarga, 'valores', []);
      self.$set(nuevaPrecarga, 'condiciones', []);
      self.$set(nuevaPrecarga, 'provincias', []);;
      form.precargas.push(nuevaPrecarga)
    },
    nuevaCondicionPrecarga(precarga){
      var self = this;
      if(!precarga.condiciones){
        self.$set(precarga, 'condiciones', []);
      }
      precarga.condiciones.push({});
    },
    nuevoValorPrecarga(ip){
      var self = this;
      var form = self.$refs.rform.formData;
      var nuevoValor = {};
      self.$set(nuevoValor, "resultado", null);
      self.$set(nuevoValor, "bloqueado", false);
      self.$set(nuevoValor, "codigo", null);
      form.precargas[ip].valores.push(nuevoValor);
    },
    setValorComprobacion(ip,iv,valor){
      var self = this;
      var formato = self.$refs.rform.formData;
      self.$set(formato.precargas[ip].valores[iv], 'resultado', valor);
    },
    getValorComprobacion(ip,iv){
      var self = this;
      var formato = self.$refs.rform.formData;
      return formato.precargas[ip].valores[iv].resultado;
    },
    toggleBloqueado(ip,iv){
      var self = this;
      var formato = self.$refs.rform.formData;
      self.$set(formato.precargas[ip].valores[iv], 'bloqueado', !formato.precargas[ip].valores[iv].bloqueado);
    },
    getBloqueado(ip,iv){
      var self = this;
      var formato = self.$refs.rform.formData;
      return formato.precargas[ip].valores[iv].bloqueado;
    },
    gestionaFicherosPlantilla(formato){
      var self = this;
      if (!formato.plantillasInforme){
        self.$set(formato,"plantillasInforme", []);
        self.$set(formato.plantillasInforme, "condiciones", []);
      }
      formato.plantillasInforme.forEach(plantilla => {
        self.$set(plantilla, 'certificado', plantilla.plantillas.filter(documento => documento.tipo == self.tipos.certificado));
      });
      formato.plantillasInforme.forEach(plantilla => {
        self.$set(plantilla, 'datos', plantilla.plantillas.filter(documento => documento.tipo == self.tipos.tomaDatos));
      });
      formato.plantillasInforme.forEach(plantilla => {
        if(plantilla.certificado && plantilla.certificado.length){
          plantilla.certificadoPath = plantilla.certificado[0].path;
        }
        if(plantilla.datos && plantilla.datos.length){
          plantilla.datosPath = plantilla.datos[0].path;
        }
        if(plantilla.anexos && plantilla.anexos.length){
          plantilla.anexos.forEach(anexo => {
            anexo.anexoPath = anexo.anexo.path;
          })
        }
      });
    },
    onDrop(arr, dropResult) {
      var self = this;
      applyDrag(arr, dropResult, self);
    },
    getChildPayloadPestanas(arr) {
      if (!arr) {
        return index => ({
          nombre: index == 0 ? "" : index == 1 ? "CUADROS" : "TRANSFORMADORES",
          formato: null,
          items: null,
          tipo:
            index == 0 ? "GENERAL" : index == 1 ? "CUADROS" : "TRANSFORMADORES"
        });
      } else return index => arr[index];
    },
    getChildPayloadGrupoComprobaciones(arr) {
      if (!arr) {
        return index => ({
          codigo: null,
          nombre: null,
          esGrupo: true,
          descripcion: null,
          instrucciones: null,
          valorInicial: null,
          resultado: null,
          hijas: [],
          defectos: []
        });
      } else return index => arr[index];
    },
    getChildPayloadGrupoCaracteristicas(arr) {
      if (!arr) {
        return index => ({
          nombre: null,
          valor: null,
          descripcion: null,
          label: null,
          tipo: "GROUP",
          maxLength: null,
          help: null,
          hint: null,
          options: null,
          hijas: []
        });
      } else return index => arr[index];
    },
    getChildPayloadComprobaciones(arr) {
      var self = this;
      if (!arr) {
        return index => ({
          codigo: null,
          nombre: null,
          descripcion: null,
          instrucciones: null,
          valorInicial: null,
          resultado: null,
          hijas: [],
          defectos: [],
          name: '',
          creadaLocal: true
        });
      } else return index => arr[index];
    },
    getChildPayloadCaracteristicas(arr) {
      var self = this;
      if (!arr) {
        return index => ({
          nombre: "nuevo",
          valor: null,
          descripcion: null,
          label: null,
          tipo: self.camposCaracteristicas[index].tipo,
          maxLength: null,
          help: null,
          hint: null,
          options: [],
          hijas: []
        });
      } else return index => arr[index];
    },
    deleteItem: function() {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        self.$t("rlist.pregunta_eliminar_registro"),
        "Eliminar",
        function() {
          Materia.delete({ itemId: self.id })
            .then(function(res) {
              if (res) {
                app.toast
                  .create({
                    icon: '<i class="f7-icons">checkmark</i>',
                    text: self.$t("rlist.registro_eliminado"),
                    position: "center",
                    destroyOnClose: true,
                    closeTimeout: 2000
                  })
                  .open();
                self.$f7router.back();
              }
            })
            .catch(function(error) {
              app.dialog.alert(error.message);
            });
        }
      );
    },
    onSave: function(res) {
      var self = this;
      var app = self.$f7;
      var router = self.$f7router;
      // El back no devuelve 'accordionOpened' (campo solo de front). Guardamos el estado de despliegue
      // actual y lo reaplicamos sobre el árbol devuelto; si no, las comprobaciones que estaban abiertas
      // quedan visualmente abiertas pero sin contenido (hasta plegar/desplegar).
      var comprobacionesPrevias = self.$refs.rform.formData ? self.$refs.rform.formData.comprobaciones : null;
      // Guardar reemplaza el formato por el que devuelve el servidor sin pasar por `loadItem`, asi
      // que aqui tambien hay que salir del modo borrado: lo seleccionado apuntaba a las reglas de
      // antes de guardar y ya no existe.
      self.olvidarModoBorrado();
      self.$refs.rform.formData = res;
      self.recordarGuardado(res);
      self.gestionaFicherosPlantilla(res);
      self.restaurarAccordionOpened(comprobacionesPrevias, res ? res.comprobaciones : null);
      app.toast
        .create({
          text: self.$t("formatos.formato_guardado"),
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
    },
    // Reaplica el estado de despliegue ('accordionOpened', campo solo de front que el back no devuelve)
    // de las comprobaciones previas sobre el árbol devuelto tras guardar. Su ausencia hacía que onSave
    // lanzara un TypeError.
    restaurarAccordionOpened(previas, nuevas) {
      const self = this;
      if (!previas || !nuevas) return;
      const size = Math.min(previas.length, nuevas.length);
      for (let i = 0; i < size; i++) {
        self.$set(nuevas[i], "accordionOpened", previas[i].accordionOpened);
        self.restaurarAccordionOpened(previas[i].hijas, nuevas[i].hijas);
      }
    },
    eliminarPlantilla: function(ip){
      var self = this;
      self.$refs.rform.formData.plantillasInforme.splice(ip,1);
    },
    duplicarPlantilla: function(plantilla, idx){
      var self = this;
      let nuevaPlantilla = JSON.parse(JSON.stringify(plantilla));
      nuevaPlantilla.nombre = nuevaPlantilla.nombre + " - Copia";
      self.$refs.rform.formData.plantillasInforme.splice(idx+1,0,nuevaPlantilla);
    },
    eliminarCondicionPlantilla: function(ip, ic){
      var self = this;
      self.$refs.rform.formData.plantillasInforme[ip].condiciones.splice(ic,1);
    },
    eliminarPrecarga: function(ip){
      var self = this;
      self.$refs.rform.formData.precargas.splice(ip,1);
    },
    duplicarPrecarga: function(ip){
      var self = this;
      var precarga = self.$refs.rform.formData.precargas[ip];
      var nuevaPrecarga = JSON.parse(JSON.stringify(precarga));
      nuevaPrecarga.nombre = nuevaPrecarga.nombre + " - DUPLICADA";
      self.$refs.rform.formData.precargas.push(nuevaPrecarga);
    },
    eliminarCondicionPrecarga: function(ip, ic){
      var self = this;
      self.$refs.rform.formData.precargas[ip].condiciones.splice(ic,1);
    },
    _fixOptionsCaracteristica: function(caracteristica) {
      var self = this;
      var nuevaCaracteristica = Object.assign({}, caracteristica);
      if(nuevaCaracteristica.options){
          nuevaCaracteristica.options = nuevaCaracteristica.options.map(option => (option == null) ? '' : option);
      }
      if(nuevaCaracteristica.hijas && nuevaCaracteristica.hijas.length){
          nuevaCaracteristica.hijas = nuevaCaracteristica.hijas.map(hija => self._fixOptionsCaracteristica(hija));
      }
      return nuevaCaracteristica;
    },
    nuevoAnexo: function(plantilla) {
      const self = this;
      if(!plantilla.anexos){
        self.$set(plantilla, "anexos", []);
      }
      plantilla.anexos.push({});
    },
    eliminarAnexoPlantilla: function(ip, ic){
      var self = this;
      self.$refs.rform.formData.plantillasInforme[ip].anexos.splice(ic,1);
    },
  },
  created: function() {
    var self = this;
    DocumentoGestion.getListaDocumentosPorTipo("EXPEDIENTE").then(res => {
      self.documentosPlantilla = res.list;
      if(self.$refs.documentosPlantilla) {
        if(self.$refs.documentosPlantilla.length){
          self.$refs.documentosPlantilla.forEach(comboPlantilla => { comboPlantilla.reload(self.documentosPlantilla); });
        } else {
          self.$refs.documentosPlantilla.reload(self.documentosPlantilla);
        }
      }
    });
  },
  mounted: function() {
    var self = this;
    // El barrido lo conduce el servidor y lo narra por el canal de difusión: aquí solo se pinta.
    // La suscripción vive mientras viva la pantalla; el canal sigue abierto al salir para poder
    // avisar del final aunque quien lo lanzó se haya ido a otra cosa.
    self._onGeneracionReglas = function (payload) { self.aplicarEstadoGeneracion(payload); };
    GeneracionReglasEvents.subscribe(self._onGeneracionReglas, self.$f7);
    var $ = self.$$;
    var $el = $(self.$el);
    var app = self.$f7;
    if(self.version) {
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Formato.getVersion({itemId:self.id}).then(function(res) {
        // #1001 · Si el código del anterior no sigue el patrón, el API no puede proponer el
        // siguiente y lo deja vacío: entonces lo escribe quien crea la edición.
        self.codigoEdicionEditable = !res.codigo;
        self.$set(self.$refs.rform,"formData",res);
        self.loadItem(res, true);
      }).catch(function(error) {
        app.dialog.alert(error.message);
        self.$f7router.back();
      }).finally(function(res) {
        espera.cerrar();
      });
    }
    self.habilitarPrecargas();
  }
};
</script>